import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  Tabs,
  Form,
  Row,
  Col,
  Select,
  Button,
  BackTop,
  Icon,
  Modal,
  Tooltip,
  Input,
  message,
  Spin,
  Radio,
  Checkbox
} from 'antd';
import AddNewDomainToBlacklistForm from './components/AddNewDomainToBlacklistForm';
import { ImageStatus } from './filters/ImageStatus';
import { AgencyId } from './filters/AgencyId';
import { ImageId } from './filters/ImageId';
import { UsageUrl } from './filters/UsageUrl';
import { ImageUrl } from './filters/ImageUrl';
import {
  deleteDomainFromBlacklist,
  addManyNewDomainsToBlacklisted,
  getDomainByName,
  getDomainsByUsageUrl,
  getDomainsByClickhouseUsageUrl,
  getBlacklistedDomainByName,
  getImagesByAgencyAndId,
  getDomainFlowStatuses,
  getCountriesList,
  changeUsageImagesData,
  getUsageUrlCount,
  changeClickhouseUsageImagesData,
  getDomainsByClickhouseArchiveUsageUrl
} from '../../redux/action/search/SearchActions';
import { updateImageStatus } from '../../redux/action/qc_fr/QC_FRActions';
import { getImagesTableAgencies } from '../../redux/action/common/CommonActions';
import { setBulkChanges } from '../../redux/action/finalReviewPage/finalReviewPage';
import {
  FIELD_QUERY_TYPES,
  IMAGES_TABLE_FIELDS_FILTER,
  IMAGES_TABLE_COLUMNS,
  DOMAINS_TABLE_COLUMNS,
  USAGE_URL_TABLE_COLUMNS,
  BLACKLISTED_TABLE_FIELDS_FILTER,
  BLACKLISTED_TABLE_COLUMNS,
  IMAGE_STATUSES
} from './SearchPageConstants';
import TableComponent from './components/TableComponent';
import UsageUrlTable from './components/UsageUrlTable';
import './SearchPage.css';
import { Country } from './filters/Country';
import { DifferenceFilter } from './filters/Difference';
import { FoundAtFilter } from './filters/FoundAt';
import { NonVerifiedCountry } from './filters/NonVerifiedCountry';
import { Domain } from './filters/Domain';

const { TabPane } = Tabs;
const { Option } = Select;
const { Search, TextArea } = Input;

class SearchPage extends Component {
  constructor(props) {
    super(props);

    let selectedBlacklistedFilterOptions = {};
    let selectedImagesFilterOptions = {};
    let selectedFields = [];
    let preparedDataForFilter = _.map(
      Object.keys(BLACKLISTED_TABLE_FIELDS_FILTER),
      (fieldName) => {
        if (IMAGES_TABLE_FIELDS_FILTER[fieldName]) {
          selectedImagesFilterOptions = {
            [fieldName]: {
              field: fieldName,
              operands: [],
              operator: 'EQ',
              componentType: 'input'
            }
          };
        }
        if (BLACKLISTED_TABLE_FIELDS_FILTER[fieldName].visibility) {
          selectedBlacklistedFilterOptions = {
            [fieldName]: {
              field: fieldName,
              operands: [],
              operator: 'EQ',
              componentType: 'input'
            }
          };
        }

        selectedFields.push(fieldName);
        return {
          key: fieldName,
          selectorOptions:
            BLACKLISTED_TABLE_FIELDS_FILTER[fieldName].selectorTypes,
          filterOptions:
            FIELD_QUERY_TYPES[
              BLACKLISTED_TABLE_FIELDS_FILTER[fieldName].componentType
            ],
          visibility: BLACKLISTED_TABLE_FIELDS_FILTER[fieldName].visibility
        };
      }
    );

    /* Set current tab from path */
    const { path } = this.props.match;
    const usageUrlName = 'usage_url';
    const clickhouseUsageUrl = 'clickhouse_usage_url';
    const urlSearchParams = new URLSearchParams(this.props.location.search);
    let defaultTab = 'images';
    let imageStatus = { order: '' };
    let agencyId = { order: '' };
    let imageId = { order: '' };
    let usageUrl = { order: '' };
    let imageUrl = { order: '' };
    let domain = { order: '' };
    let country = { order: '' };
    let scrapedCountry = { order: '' };
    let difference = { order: '' };
    let facebook = false;
    let facebookNotDefined = false;

    let imageStatusHouse = { order: '' };
    let agencyIdHouse = { order: '' };
    let imageIdHouse = { order: '' };
    let usageUrlHouse = { order: '' };
    let imageUrlHouse = { order: '' };
    let domainHouse = { order: '' };
    let countryHouse = { order: '' };
    let scrapedCountryHouse = { order: '' };
    let differenceHouse = { order: '' };

    if (path.includes(usageUrlName)) {
      defaultTab = 'usageUrl';

      if (urlSearchParams.get('image_status')) {
        const statuses = urlSearchParams.get('image_status');
        imageStatus['value'] = statuses.split(',');
      }

      if (urlSearchParams.get('agency')) {
        const agency = urlSearchParams.get('agency');
        agencyId['value'] = agency.split(',');
      }

      if (urlSearchParams.get('image_id')) {
        const id = urlSearchParams.get('image_id');
        imageId['value'] = id;
      }

      if (urlSearchParams.get('usage_url')) {
        const usage_url = urlSearchParams.get('usage_url');
        usageUrl['value'] = usage_url;
      }

      if (urlSearchParams.get('image_url')) {
        const image_url = urlSearchParams.get('image_url');
        imageUrl['value'] = image_url;
      }

      if (urlSearchParams.get('domain')) {
        const domainUrl = urlSearchParams.get('domain');
        domain['value'] = domainUrl;
      }

      if (urlSearchParams.get('country')) {
        const countryValues = urlSearchParams.get('country');
        const countriesMap = countryValues
          .split(',')
          .filter((item) => item !== '');
        country['value'] = countriesMap;
      }

      if (urlSearchParams.get('non_verified_country')) {
        const scrapedCountryValues = urlSearchParams.get(
          'non_verified_country'
        );
        const countriesMap = scrapedCountryValues
          .split(',')
          .filter((item) => item !== '');
        country['value'] = countriesMap;
        scrapedCountry['value'] = countriesMap;
      }

      if (urlSearchParams.get('difference_max')) {
        const difference_max = urlSearchParams.get('difference_max');
        difference['differenceEnd'] = difference_max;
      }

      if (urlSearchParams.get('difference_min')) {
        const difference_min = urlSearchParams.get('difference_min');
        difference['differenceStart'] = difference_min;
      }

      if (urlSearchParams.get('facebook')) {
        const facebookValue = urlSearchParams.get('facebook');
        facebook = facebookValue;
      }

      if (urlSearchParams.get('facebook_not_defined')) {
        const facebook_not_defined = urlSearchParams.get(
          'facebook_not_defined'
        );
        facebookNotDefined = facebook_not_defined;
      }
    }

    if (path.includes(clickhouseUsageUrl)) {
      defaultTab = 'clickhouseUsageUrl';

      if (urlSearchParams.get('image_status')) {
        const statuses = urlSearchParams.get('image_status');
        imageStatusHouse['value'] = statuses.split(',');
      }

      if (urlSearchParams.get('agency')) {
        const agency = urlSearchParams.get('agency');
        agencyIdHouse['value'] = agency.split(',');
      }

      if (urlSearchParams.get('image_id')) {
        const id = urlSearchParams.get('image_id');
        imageIdHouse['value'] = id;
      }

      if (urlSearchParams.get('usage_url')) {
        const usage_url = urlSearchParams.get('usage_url');
        usageUrlHouse['value'] = usage_url;
      }

      if (urlSearchParams.get('image_url')) {
        const image_url = urlSearchParams.get('image_url');
        imageUrlHouse['value'] = image_url;
      }

      if (urlSearchParams.get('domain')) {
        const domainUrl = urlSearchParams.get('domain');
        domainHouse['value'] = domainUrl;
      }

      if (urlSearchParams.get('country')) {
        const countryValues = urlSearchParams.get('country');
        const countriesMap = countryValues
          .split(',')
          .filter((item) => item !== '');
        country['value'] = countriesMap;
      }

      if (urlSearchParams.get('non_verified_country')) {
        const scrapedCountryValues = urlSearchParams.get(
          'non_verified_country'
        );
        const countriesMap = scrapedCountryValues
          .split(',')
          .filter((item) => item !== '');
        country['value'] = countriesMap;
        scrapedCountry['value'] = countriesMap;
      }

      if (urlSearchParams.get('difference_max')) {
        const difference_max = urlSearchParams.get('difference_max');
        differenceHouse['differenceEnd'] = difference_max;
      }

      if (urlSearchParams.get('difference_min')) {
        const difference_min = urlSearchParams.get('difference_min');
        differenceHouse['differenceStart'] = difference_min;
      }

      if (urlSearchParams.get('facebook')) {
        const facebookValue = urlSearchParams.get('facebook');
        facebook = facebookValue;
      }

      if (urlSearchParams.get('facebook_not_defined')) {
        const facebook_not_defined = urlSearchParams.get(
          'facebook_not_defined'
        );
        facebookNotDefined = facebook_not_defined;
      }
    }

    preparedDataForFilter = preparedDataForFilter.filter((f) => f.visibility);

    this.state = {
      arciveSearch: false,
      copyright: false,
      copyrightClickhouse: false,
      imageIdExactSearch: false,
      selectedTabKey: 'images',
      domainName: '%25',
      showAddNewDomainModal: false,
      loaderIsVisible: false,
      isVisibleConfirm: false,
      selectedImagesFields: selectedFields,
      selectedDomainsFields: selectedFields,
      selectedDomainsFieldsClickhouse: selectedFields,
      selectedBlacklistedFields: selectedFields,
      preparedImagesFilterData: [],
      preparedDomainsFilterData: [],
      preparedBlacklistedFilterData: preparedDataForFilter.filter(
        (f) => f.visibility
      ),
      selectedImagesFilterOptions: selectedImagesFilterOptions,
      selectedBlacklistedFilterOptions: selectedBlacklistedFilterOptions,
      imagesTableSortedOption: {},
      domainsTableSortedOption: {},
      usageUrlTableSortedOption: {},
      usageClickhouseUrlTableSortedOption: {},
      blacklistedTableSortedOption: {},
      showImagesFilter: false,
      showDomainsFilter: false,
      showBlacklistedFilter: false,
      imagesPaginationOptions: {
        pageNumber: 1,
        pageSize: 10
      },
      domainsPaginationOptions: {
        pageNumber: 1,
        pageSize: 10
      },
      usageUrlPaginationOptions: {
        pageNumber: 1,
        pageSize: 1000
      },
      usageClickhouseUrlPaginationOptions: {
        pageNumber: 1,
        pageSize: 1000
      },
      blacklistedPaginationOptions: {
        pageNumber: 1,
        pageSize: 10
      },
      domainSearchInput: '',
      usageUrlSearchInput: '',
      usageClickhouseUrlSearchInput: '',
      blacklistedDomainSearchInput: '',
      imagesAgency: '',
      imagesAgencyId: '',
      selectedRowKeys: [],
      selectedImagesIds: [],
      sightingsFilters: {
        imageStatus: imageStatus,
        agencyId: agencyId,
        imageId: imageId,
        usageUrl: usageUrl,
        imageUrl: imageUrl,
        domain: domain,
        country: country,
        scrapedCountry: scrapedCountry,
        difference: difference,
        dates: { order: '' }
      },
      sightingsClickhouseFilters: {
        imageStatus: imageStatusHouse,
        agencyId: agencyIdHouse,
        imageId: imageIdHouse,
        usageUrl: usageUrlHouse,
        imageUrl: imageUrlHouse,
        domain: domainHouse,
        country: countryHouse,
        scrapedCountry: scrapedCountryHouse,
        difference: differenceHouse,
        dates: { order: '' }
      },
      usagesUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      },
      usagesClickhouseUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      },
      undefineCountry: false,
      undefineNonCountry: false,
      undefineCountryClickhouse: false,
      undefineNonCountryClickhouse: false,
      socialNetwork: false,
      facebook: facebook,
      exactMatches: false,
      exactMatchesClickhouse: false,
      visibleUsageError: false,
      facebookNotDefined: facebookNotDefined,
      clickhouseFacebook: false,
      clickhouseFacebookNotDefined: false,
      defaultTabKey: defaultTab
    };
  }

  componentDidMount() {
    this.props.getImagesTableAgencies();
    this.props.getCountriesList();
    this.props.getDomainFlowStatuses();

    if (!this.props.userInfo.userPermissions?.tablePermission) {
      window.location = '/403';
    }
  }

  // componentDidUpdate(prevProps, state) {
  //   console.log(prevProps);
  //   if (!_.isEqual(prevProps.usageImagesData, this.props.usageImagesData)) {
  //     console.log(prevProps.usageImagesData, this.props.usageImagesData);
  //     this.prepareUsageUrlTableData();
  //   }
  // }

  handleRouteTo = (path) => {
    window.location.pathname = path;
  };

  convertToBool = (str) => {
    if (str === 'true') return true;
    if (str === 'false') return false;
    if (str === 'all') return null;
  };

  handleApplyFilter = (mainType) => {
    // let requestData = {};
    let paginationOptions = {
      page: 0,
      size: 0
    };

    if (mainType === 'images') {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const {
            agency,
            imageId,
            domain,
            country,
            imagesCount,
            identicalCount,
            status,
            commercial,
            pursuable,
            notBlacklisted
          } = values;

          paginationOptions = {
            page: this.state.imagesPaginationOptions.pageNumber - 1,
            size: this.state.imagesPaginationOptions.pageSize
          };

          let requestData = {
            agency: !_.isEmpty(agency) ? agency : '',
            imageId: !_.isEmpty(imageId) ? imageId : '',
            domains: !_.isEmpty(domain) ? domain.split(', ') : [],
            country: !_.isEmpty(country) ? country : '',
            imagesCount: !_.isEmpty(imagesCount) ? imagesCount : null,
            identicalCount: !_.isEmpty(identicalCount) ? identicalCount : null,
            status: !_.isEmpty(status) ? status : '',
            commercial: this.convertToBool(commercial),
            pursuable: this.convertToBool(pursuable),
            notBlacklisted: this.convertToBool(notBlacklisted)
          };

          this.setState({
            loaderIsVisible: true
          });
          this.props
            .getImagesByAgencyAndId(
              requestData,
              paginationOptions,
              this.state.imagesTableSortedOption
            )
            .then(() =>
              this.setState({
                loaderIsVisible: false
              })
            )
            .then(() => {
              if (!_.isEmpty(this.props.getImagesByAgencyAndIdErrorMessage)) {
                message.error(
                  this.props.getImagesByAgencyAndIdErrorMessage.error,
                  3
                );
              }
            });
        }
      });
    } else if (mainType === 'domains') {
      paginationOptions = {
        page: this.state.domainsPaginationOptions.pageNumber - 1,
        size: this.state.domainsPaginationOptions.pageSize
      };

      this.props.form.validateFields((err, values) => {
        if (!err) {
          const {
            ddomain,
            ddomain2,
            dcountry,
            dscrapedCountry,
            dimagesCount,
            didenticalCount,
            dstatus,
            dcommercial,
            dpursuable,
            dnotBlacklisted,
            dsocialDomain
          } = values;

          const domainHandler = () => {
            if (!_.isEmpty(ddomain2)) {
              const domain =
                `${ddomain.trim()}%${ddomain2.trim()}, ${ddomain2.trim()}%${ddomain.trim()}`.split(
                  ', '
                );
              return domain;
            }
            if (!_.isEmpty(ddomain)) {
              return ddomain.trim().split(', ');
            } else return [];
          };

          let requestData = {
            domains: !_.isEmpty(ddomain) && domainHandler(),
            country: !_.isEmpty(dcountry) ? dcountry : '',
            scrapedCountry: !_.isEmpty(dscrapedCountry) ? dscrapedCountry : '',
            imagesCount: !_.isEmpty(dimagesCount) ? dimagesCount : null,
            identicalCount: !_.isEmpty(didenticalCount)
              ? didenticalCount
              : null,
            status: !_.isEmpty(dstatus) ? dstatus : '',
            commercial: this.convertToBool(dcommercial),
            pursuable: this.convertToBool(dpursuable),
            notBlacklisted: this.convertToBool(dnotBlacklisted),
            socialDomain: this.convertToBool(dsocialDomain)
          };

          if (!ddomain && !ddomain2) {
            message.error('Search value can not be empty!');
            return;
          }

          if (!ddomain) {
            return;
          }

          this.setState({
            loaderIsVisible: true
          });
          this.props
            .getDomainByName(
              requestData,
              paginationOptions,
              this.state.domainsTableSortedOption
            )
            .then(() =>
              this.setState({
                loaderIsVisible: false
              })
            )
            .then(() => {
              if (!_.isEmpty(this.props.getDomainByNameErrorMessage)) {
                message.error(this.props.getDomainByNameErrorMessage.error, 3);
              }
            });
        }
      });
    } else if (mainType === 'usageUrl') {
      this.props.form.validateFields((err, values) => {
        if (!err) {
          const { usageUrl, usageRadio } = values;
          const { sightingsFilters, usagesUrlSelectFilters } = this.state;

          const usageUrlPart = !_.isEmpty(sightingsFilters.usageUrl.value)
            ? sightingsFilters.usageUrl.value
            : null;

          const isNullBlacklised =
            _.isNull(usagesUrlSelectFilters.blacklisted) ||
            usagesUrlSelectFilters.blacklisted === 'null';

          const requestData = {
            part: usageRadio === 'usagePart' ? usageUrl : null,
            domainPart: usageRadio === 'usagePartDomain' ? usageUrl : null,
            sourcePart: usageRadio === 'usagePartSource' ? usageUrl : null,
            socialNetwork: this.state.socialNetwork,
            domainExactSearch: this.state.exactMatches,
            imageIdExactSearch: this.state.imageIdExactSearch,
            facebook: this.state.facebook ? this.state.facebook : null,
            facebookNotDefined: this.state.facebookNotDefined
              ? this.state.facebookNotDefined
              : null,
            partForFilter: usageUrlPart,
            status: !_.isEmpty(sightingsFilters.imageStatus.value)
              ? [...sightingsFilters.imageStatus.value]
              : null,
            agency: !_.isEmpty(sightingsFilters.agencyId.value)
              ? [...sightingsFilters.agencyId.value]
              : null,
            imageId: !_.isEmpty(sightingsFilters.imageId.value)
              ? sightingsFilters.imageId.value
              : null,
            imageUrl: !_.isEmpty(sightingsFilters.imageUrl.value)
              ? sightingsFilters.imageUrl.value
              : null,
            domain: !_.isEmpty(sightingsFilters.domain.value)
              ? sightingsFilters.domain.value
              : null,
            pursuable: usagesUrlSelectFilters.pursuable,
            differenceStart: !_.isEmpty(
              sightingsFilters.difference?.differenceStart
            )
              ? sightingsFilters.difference?.differenceStart
              : null,
            differenceEnd: !_.isEmpty(
              sightingsFilters.difference?.differenceEnd
            )
              ? sightingsFilters.difference?.differenceEnd
              : null,
            foundAtStart: !_.isEmpty(sightingsFilters.dates.foundAtStart)
              ? sightingsFilters.dates.foundAtStart
              : null,
            foundAtEnd: !_.isEmpty(sightingsFilters.dates.foundAtEnd)
              ? sightingsFilters.dates.foundAtEnd
              : null,
            blacklisted: isNullBlacklised
              ? null
              : !this.convertToBool(usagesUrlSelectFilters.blacklisted),
            country: this.state.undefineCountry
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsFilters.country.value)
              ? [...sightingsFilters.country.value]
              : null,
            scrapedCountry: this.state.undefineNonCountry
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsFilters.scrapedCountry.value)
              ? [...sightingsFilters.scrapedCountry.value]
              : null,
            registeredImage: this.state.copyright
          };

          paginationOptions = {
            page: this.state.usageUrlPaginationOptions.pageNumber - 1,
            size: this.state.usageUrlPaginationOptions.pageSize
          };

          const sortingOptions = {
            status: sightingsFilters.imageStatus.order,
            agency: sightingsFilters.agencyId.order,
            imageId: sightingsFilters.imageId.order,
            imageUrl: sightingsFilters.imageUrl.order,
            domain: sightingsFilters.imageUrl.order,
            usageUrl: sightingsFilters.usageUrl.order,
            difference: sightingsFilters.difference.order
          };

          // if (!usageUrl || !usageRadio) {
          //   message.error('Search values can not be empty!');
          //   return;
          // }

          // if (usageUrl.trim().length < 3) {
          //   message.error('Search value should be at least 3 symbols!');
          //   return;
          // }

          this.setState({
            loaderIsVisible: true
          });
          this.props
            .getDomainsByUsageUrl(
              requestData,
              paginationOptions,
              sortingOptions
            )
            .then(() =>
              this.setState({
                loaderIsVisible: false
              })
            )
            .then(() => {
              if (!_.isEmpty(this.props.getDomainsByUsageUrlErrorMessage)) {
                message.error(
                  this.props.getDomainsByUsageUrlErrorMessage.error,
                  3
                );
              }
            });
        }
      });
    } else if (mainType === 'blacklisted') {
      paginationOptions = {
        page: this.state.blacklistedPaginationOptions.pageNumber - 1,
        size: this.state.blacklistedPaginationOptions.pageSize
      };

      this.setState({
        loaderIsVisible: true
      });
      this.props
        .getBlacklistedDomainByName(
          this.state.blacklistedDomainSearchInput,
          paginationOptions,
          this.state.blacklistedTableSortedOption
        )
        .then(() =>
          this.setState({
            loaderIsVisible: false
          })
        )
        .then(() => {
          if (!_.isEmpty(this.props.getBlacklistedDomainByNameErrorMessage)) {
            message.error(
              this.props.getBlacklistedDomainByNameErrorMessage.error,
              3
            );
          }
        });
    }
  };

  handleTablePaginationChange = (type, page, pageSize) => {
    let typeName = '';
    if (type === 'images') {
      typeName = 'imagesPaginationOptions';
    } else if (type === 'domains') {
      typeName = 'domainsPaginationOptions';
    } else if (type === 'usageUrl') {
      typeName = 'usageUrlPaginationOptions';
    } else if (type === 'blacklisted') {
      typeName = 'blacklistedPaginationOptions';
    } else if (type === 'clickhouseUsageUrl') {
      typeName = 'usageClickhouseUrlPaginationOptions';
    }

    this.setState(
      {
        [typeName]: {
          pageNumber: page,
          pageSize: pageSize
        }
      },
      () => {
        this.handleApplyFilter(type);
      }
    );
  };

  handleColumnSortChange = (type, columnData) => {
    // let requestData = {};
    let paginationOptions = {
      page: 0,
      size: 10
    };
    let newSortingOption = {};
    let deleteSortOption = false;

    if (type === 'images') {
      paginationOptions = {
        page: this.state.imagesPaginationOptions.pageNumber - 1,
        size: this.state.imagesPaginationOptions.pageSize
      };

      if (
        this.state.imagesTableSortedOption.hasOwnProperty(columnData.fieldKey)
      ) {
        let newSortType =
          this.state.imagesTableSortedOption[columnData.fieldKey].type === 'ASC'
            ? 'DESC'
            : '';

        if (
          this.state.imagesTableSortedOption[columnData.fieldKey].type ===
          'DESC'
        ) {
          deleteSortOption = true;
        }

        newSortingOption = {
          [columnData.fieldKey]: {
            type: newSortType
          }
        };
      } else {
        newSortingOption = {
          [columnData.fieldKey]: {
            type: 'ASC'
          }
        };
      }

      if (deleteSortOption) {
        newSortingOption = {};
      }

      this.props.form.validateFields((err, values) => {
        if (!err) {
          const {
            agency,
            imageId,
            domain,
            country,
            imagesCount,
            identicalCount,
            sightingsById,
            identicalSightingsById,
            status,
            commercial,
            pursuable,
            notBlacklisted
          } = values;

          let requestData = {
            agency: !_.isEmpty(agency) ? agency : '',
            imageId: !_.isEmpty(imageId) ? imageId : '',
            domains: !_.isEmpty(domain) ? domain.split(', ') : [],
            country: !_.isEmpty(country) ? country : '',
            imagesCount: !_.isEmpty(imagesCount) ? imagesCount : null,
            identicalCount: !_.isEmpty(identicalCount) ? identicalCount : null,
            searchedImageCount: !_.isEmpty(sightingsById)
              ? sightingsById
              : null,
            searchedImageIdenticalCount: !_.isEmpty(identicalSightingsById)
              ? identicalSightingsById
              : null,
            status: !_.isEmpty(status) ? status : '',
            commercial: this.convertToBool(commercial),
            pursuable: this.convertToBool(pursuable),
            notBlacklisted: this.convertToBool(notBlacklisted)
          };

          this.setState(
            {
              loaderIsVisible: true,
              imagesTableSortedOption: newSortingOption
            },
            () => {
              this.props
                .getImagesByAgencyAndId(
                  requestData,
                  paginationOptions,
                  newSortingOption
                )
                .then(() => {
                  if (
                    !_.isEmpty(this.props.getImagesByAgencyAndIdErrorMessage)
                  ) {
                    message.error(
                      this.props.getImagesByAgencyAndIdErrorMessage.error,
                      3
                    );
                  } else {
                    this.setState({
                      loaderIsVisible: false
                    });
                  }
                });
            }
          );
        }
      });
    } else if (type === 'domains') {
      paginationOptions = {
        page: this.state.domainsPaginationOptions.pageNumber - 1,
        size: this.state.domainsPaginationOptions.pageSize
      };

      if (
        this.state.domainsTableSortedOption.hasOwnProperty(columnData.fieldKey)
      ) {
        let newSortType =
          this.state.domainsTableSortedOption[columnData.fieldKey].type ===
          'ASC'
            ? 'DESC'
            : '';

        if (
          this.state.domainsTableSortedOption[columnData.fieldKey].type ===
          'DESC'
        ) {
          deleteSortOption = true;
        }

        newSortingOption = {
          [columnData.fieldKey]: {
            type: newSortType
          }
        };
      } else {
        newSortingOption = {
          [columnData.fieldKey]: {
            type: 'ASC'
          }
        };
      }

      if (deleteSortOption) {
        newSortingOption = {};
      }

      this.props.form.validateFields((err, values) => {
        if (!err) {
          const {
            ddomain,
            dcountry,
            dscrapedCountry,
            dimagesCount,
            didenticalCount,
            dstatus,
            dcommercial,
            dpursuable,
            dnotBlacklisted,
            dsocialDomain
          } = values;

          let requestData = {
            domains: !_.isEmpty(ddomain) ? ddomain.split(', ') : [],
            country: !_.isEmpty(dcountry) ? dcountry : '',
            scrapedCountry: !_.isEmpty(dscrapedCountry) ? dscrapedCountry : '',
            imagesCount: !_.isEmpty(dimagesCount) ? dimagesCount : null,
            identicalCount: !_.isEmpty(didenticalCount)
              ? didenticalCount
              : null,
            status: !_.isEmpty(dstatus) ? dstatus : '',
            commercial: this.convertToBool(dcommercial),
            pursuable: this.convertToBool(dpursuable),
            notBlacklisted: this.convertToBool(dnotBlacklisted),
            socialDomain: this.convertToBool(dsocialDomain)
          };

          this.setState(
            {
              loaderIsVisible: true,
              domainsTableSortedOption: newSortingOption
            },
            () => {
              this.props
                .getDomainByName(
                  requestData,
                  paginationOptions,
                  newSortingOption
                )
                .then(() => {
                  if (!_.isEmpty(this.props.getDomainByNameErrorMessage)) {
                    message.error(
                      this.props.getDomainByNameErrorMessage.error,
                      3
                    );
                  } else {
                    this.setState({
                      loaderIsVisible: false
                    });
                  }
                });
            }
          );
        }
      });
    } else if (type === 'usageUrl') {
      paginationOptions = {
        page: this.state.usageUrlPaginationOptions.pageNumber - 1,
        size: this.state.usageUrlPaginationOptions.pageSize
      };

      if (
        this.state.usageUrlTableSortedOption.hasOwnProperty(columnData.fieldKey)
      ) {
        let newSortType =
          this.state.usageUrlTableSortedOption[columnData.fieldKey].type ===
          'ASC'
            ? 'DESC'
            : '';
        if (
          this.state.usageUrlTableSortedOption[columnData.fieldKey].type ===
          'DESC'
        ) {
          deleteSortOption = true;
        }

        newSortingOption = {
          [columnData.fieldKey]: {
            type: newSortType
          }
        };
      } else {
        newSortingOption = {
          [columnData.fieldKey]: {
            type: 'ASC'
          }
        };
      }

      if (deleteSortOption) {
        newSortingOption = {};
      }

      this.props.form.validateFields((err, values) => {
        if (!err) {
          const { usageUrl, usageRadio } = values;
          const { sightingsFilters, usagesUrlSelectFilters } = this.state;

          const usageUrlPart = !_.isEmpty(sightingsFilters.usageUrl.value)
            ? sightingsFilters.usageUrl.value
            : null;

          const requestData = {
            part: usageRadio === 'usagePart' ? usageUrl : null,
            domainPart: usageRadio === 'usagePartDomain' ? usageUrl : null,
            sourcePart: usageRadio === 'usagePartSource' ? usageUrl : null,
            socialNetwork: this.state.socialNetwork,
            domainExactSearch: this.state.exactMatches,
            imageIdExactSearch: this.state.imageIdExactSearch,
            facebook: this.state.facebook ? this.state.facebook : null,
            facebookNotDefined: this.state.facebookNotDefined
              ? this.state.facebookNotDefined
              : null,
            partForFilter: usageUrlPart,
            status: !_.isEmpty(sightingsFilters.imageStatus.value)
              ? [...sightingsFilters.imageStatus.value]
              : null,
            agency: !_.isEmpty(sightingsFilters.agencyId.value)
              ? [...sightingsFilters.agencyId.value]
              : null,
            imageId: !_.isEmpty(sightingsFilters.imageId.value)
              ? sightingsFilters.imageId.value
              : null,
            imageUrl: !_.isEmpty(sightingsFilters.imageUrl.value)
              ? sightingsFilters.imageUrl.value
              : null,
            domain: !_.isEmpty(sightingsFilters.domain.value)
              ? sightingsFilters.domain.value
              : null,
            pursuable: usagesUrlSelectFilters.pursuable,
            differenceStart: !_.isEmpty(
              sightingsFilters.difference?.differenceStart
            )
              ? sightingsFilters.difference?.differenceStart
              : null,
            differenceEnd: !_.isEmpty(
              sightingsFilters.difference?.differenceEnd
            )
              ? sightingsFilters.difference?.differenceEnd
              : null,
            foundAtStart: !_.isEmpty(sightingsFilters.dates.foundAtStart)
              ? sightingsFilters.dates.foundAtStart
              : null,
            foundAtEnd: !_.isEmpty(sightingsFilters.dates.foundAtEnd)
              ? sightingsFilters.dates.foundAtEnd
              : null,
            country: this.state.undefineCountry
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsFilters.country.value)
              ? [...sightingsFilters.country.value]
              : null,
            scrapedCountry: this.state.undefineNonCountry
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsFilters.scrapedCountry.value)
              ? [...sightingsFilters.scrapedCountry.value]
              : null,
            registeredImage: this.state.copyright
          };

          this.setState(
            {
              loaderIsVisible: true,
              usageUrlTableSortedOption: newSortingOption
            },
            () => {
              this.props
                .getDomainsByUsageUrl(
                  requestData,
                  paginationOptions,
                  newSortingOption
                )
                .then(() => {
                  if (!_.isEmpty(this.props.getDomainsByUsageUrlErrorMessage)) {
                    message.error(
                      this.props.getDomainsByUsageUrlErrorMessage.error,
                      3
                    );
                  } else {
                    this.setState({
                      loaderIsVisible: false
                    });
                  }
                });
            }
          );
        }
      });
    } else if ('blacklisted') {
      paginationOptions = {
        page: this.state.blacklistedPaginationOptions.pageNumber - 1,
        size: this.state.blacklistedPaginationOptions.pageSize
      };

      if (
        this.state.blacklistedTableSortedOption.hasOwnProperty(
          columnData.fieldKey
        )
      ) {
        let newSortType =
          this.state.blacklistedTableSortedOption[columnData.fieldKey].type ===
          'ASC'
            ? 'DESC'
            : '';

        if (
          this.state.blacklistedTableSortedOption[columnData.fieldKey].type ===
          'DESC'
        ) {
          deleteSortOption = true;
        }

        newSortingOption = {
          [columnData.fieldKey]: {
            type: newSortType
          }
        };
      } else {
        newSortingOption = {
          [columnData.fieldKey]: {
            type: 'ASC'
          }
        };
      }

      if (deleteSortOption) {
        newSortingOption = {};
      }

      this.setState(
        {
          blacklistedTableSortedOption: newSortingOption
        },
        () => {
          this.props
            .getBlacklistedDomainByName(
              this.state.blacklistedDomainSearchInput,
              paginationOptions,
              newSortingOption
            )
            .then(() => {
              if (
                !_.isEmpty(this.props.getBlacklistedDomainByNameErrorMessage)
              ) {
                message.error(
                  this.props.getBlacklistedDomainByNameErrorMessage.error,
                  3
                );
              }
            });
        }
      );
    } else if (type === 'clickhouseUsageUrl') {
      paginationOptions = {
        page: this.state.usageClickhouseUrlPaginationOptions.pageNumber - 1,
        size: this.state.usageClickhouseUrlPaginationOptions.pageSize
      };

      if (
        this.state.usageClickhouseUrlTableSortedOption.hasOwnProperty(
          columnData.fieldKey
        )
      ) {
        let newSortType =
          this.state.usageClickhouseUrlTableSortedOption[columnData.fieldKey]
            .type === 'ASC'
            ? 'DESC'
            : '';
        if (
          this.state.usageClickhouseUrlTableSortedOption[columnData.fieldKey]
            .type === 'DESC'
        ) {
          deleteSortOption = true;
        }

        newSortingOption = {
          [columnData.fieldKey]: {
            type: newSortType
          }
        };
      } else {
        newSortingOption = {
          [columnData.fieldKey]: {
            type: 'ASC'
          }
        };
      }

      if (deleteSortOption) {
        newSortingOption = {};
      }

      this.props.form.validateFields((err, values) => {
        if (!err) {
          const { clickhouseUsageUrl, usageClickhouseRadio } = values;
          const {
            sightingsClickhouseFilters,
            usagesClickhouseUrlSelectFilters
          } = this.state;

          const usageUrlPart = !_.isEmpty(
            sightingsClickhouseFilters.usageUrl.value
          )
            ? sightingsClickhouseFilters.usageUrl.value
            : null;

          const isNullBlacklised =
            _.isNull(usagesClickhouseUrlSelectFilters.blacklisted) ||
            usagesClickhouseUrlSelectFilters.blacklisted === 'null';

          const requestData = {
            part:
              usageClickhouseRadio === 'usagePart' ? clickhouseUsageUrl : null,
            domainPart:
              usageClickhouseRadio === 'usagePartDomain'
                ? clickhouseUsageUrl
                : null,
            sourcePart:
              usageClickhouseRadio === 'usagePartSource'
                ? clickhouseUsageUrl
                : null,
            socialNetwork: this.state.socialNetwork,
            domainExactSearch: this.state.exactMatchesClickhouse,
            imageIdExactSearch: this.state.imageIdExactSearch,
            facebook: this.state.clickhouseFacebook
              ? this.state.clickhouseFacebook
              : null,
            facebookNotDefined: this.state.clickhouseFacebookNotDefined
              ? this.state.clickhouseFacebookNotDefined
              : null,
            partForFilter: usageUrlPart,
            status: !_.isEmpty(sightingsClickhouseFilters.imageStatus.value)
              ? [...sightingsClickhouseFilters.imageStatus.value]
              : null,
            agency: !_.isEmpty(sightingsClickhouseFilters.agencyId.value)
              ? [...sightingsClickhouseFilters.agencyId.value]
              : null,
            imageId: !_.isEmpty(sightingsClickhouseFilters.imageId.value)
              ? sightingsClickhouseFilters.imageId.value
              : null,
            imageUrl: !_.isEmpty(sightingsClickhouseFilters.imageUrl.value)
              ? sightingsClickhouseFilters.imageUrl.value
              : null,
            domain: !_.isEmpty(sightingsClickhouseFilters.domain.value)
              ? sightingsClickhouseFilters.domain.value
              : null,
            pursuable: usagesClickhouseUrlSelectFilters.pursuable,
            differenceStart: !_.isEmpty(
              sightingsClickhouseFilters.difference?.differenceStart
            )
              ? sightingsClickhouseFilters.difference?.differenceStart
              : null,
            differenceEnd: !_.isEmpty(
              sightingsClickhouseFilters.difference?.differenceEnd
            )
              ? sightingsClickhouseFilters.difference?.differenceEnd
              : null,
            foundAtStart: !_.isEmpty(
              sightingsClickhouseFilters.dates.foundAtStart
            )
              ? sightingsClickhouseFilters.dates.foundAtStart
              : null,
            foundAtEnd: !_.isEmpty(sightingsClickhouseFilters.dates.foundAtEnd)
              ? sightingsClickhouseFilters.dates.foundAtEnd
              : null,
            blacklisted: isNullBlacklised
              ? null
              : !this.convertToBool(
                  usagesClickhouseUrlSelectFilters.blacklisted
                ),
            country: this.state.undefineCountryClickhouse
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsClickhouseFilters.country.value)
              ? [...sightingsClickhouseFilters.country.value]
              : null,
            scrapedCountry: this.state.undefineNonCountryClickhouse
              ? ['UNDEFINED']
              : !_.isEmpty(sightingsClickhouseFilters.scrapedCountry.value)
              ? [...sightingsClickhouseFilters.scrapedCountry.value]
              : null,
            registeredImage: this.state.copyrightClickhouse
          };

          this.setState(
            {
              loaderIsVisible: true,
              usageClickhouseUrlTableSortedOption: newSortingOption
            },
            () => {
              if (this.state.arciveSearch) {
                this.props
                  .getDomainsByClickhouseArchiveUsageUrl(
                    requestData,
                    paginationOptions,
                    newSortingOption
                  )
                  .then(() => {
                    if (
                      !_.isEmpty(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                      )
                    ) {
                      message.error(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                          .error,
                        3
                      );
                    } else {
                      this.setState({
                        loaderIsVisible: false
                      });
                    }
                  });
              } else {
                this.props
                  .getDomainsByClickhouseUsageUrl(
                    requestData,
                    paginationOptions,
                    newSortingOption
                  )
                  .then(() => {
                    if (
                      !_.isEmpty(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                      )
                    ) {
                      message.error(
                        this.props.getDomainsByClickhouseUsageUrlErrorMessage
                          .error,
                        3
                      );
                    } else {
                      this.setState({
                        loaderIsVisible: false
                      });
                    }
                  });
              }
            }
          );
        }
      });
    }
  };

  handleCloseBlacklistedDomainModal = () => {
    this.setState({
      showAddNewDomainModal: false
    });
  };

  saveNewBlacklistedDomainToDB = (values, formInstance) => {
    this.setState(
      {
        loaderIsVisible: true
      },
      () => {
        this.props.addManyNewDomainsToBlacklisted(values).then(() => {
          if (
            !_.isEmpty(this.props.newBatchOfBlacklistedDomainDataErrorMessage)
          ) {
            this.setState(
              {
                loaderIsVisible: false
              },
              () => {
                message.error(
                  this.props.newBatchOfBlacklistedDomainDataErrorMessage.error,
                  4
                );
              }
            );
          } else {
            this.setState(
              {
                loaderIsVisible: false,
                showAddNewDomainModal: false
              },
              () => {
                let paginationOptions = {
                  page: this.state.blacklistedPaginationOptions.pageNumber - 1,
                  size: this.state.blacklistedPaginationOptions.pageSize
                };
                message.success('Domain added successfully', 4);
                formInstance.resetFields();

                this.props
                  .getBlacklistedDomainByName(
                    this.state.blacklistedDomainSearchInput,
                    paginationOptions,
                    this.state.blacklistedTableSortedOption
                  )
                  .then(() => {
                    if (
                      !_.isEmpty(
                        this.props.getBlacklistedDomainByNameErrorMessage
                      )
                    ) {
                      message.error(
                        this.props.getBlacklistedDomainByNameErrorMessage.error,
                        3
                      );
                    }
                  });
              }
            );
          }
        });
      }
    );
  };

  handleImageStatusChange = (value, imageData) => {
    const { setBulkChanges } = this.props;
    const { selectedImagesIds } = this.state;
    const ids = !_.isEmpty(selectedImagesIds)
      ? _.map(selectedImagesIds, (image) => image.id)
      : [imageData.id];

    this.setState({
      loaderIsVisible: true
    });

    Promise.resolve(
      setBulkChanges({
        ids,
        status: value
      })
    )
      .then(() => {
        this.props.changeUsageImagesData(ids, value);
        this.props.changeClickhouseUsageImagesData(ids, value);
      })
      .then(() => {
        this.setState({
          selectedImagesIds: [],
          selectedRowKeys: []
        });
      })
      .then(() =>
        this.setState({
          loaderIsVisible: false
        })
      );
  };

  renderUserActions = (domainData) => {
    return [this.renderDeleteButton(domainData)];
  };

  renderImagesCountry = (domainData) => {
    return [this.renderImagesCellCountry(domainData)];
  };

  renderImagesNonCountry = (domainData) => {
    return [this.renderImagesCellNonCountry(domainData)];
  };

  renderFlowStatus = (domainData) => {
    return [this.renderFlowCellStatus(domainData)];
  };

  renderImagesIcons = (value) => {
    return [this.renderImagesCellIcon(value)];
  };

  prepareUsageStatus = (imageData) => {
    return (
      <div
        className={`d-f-r-ac-jc ${imageData.status.toLowerCase()} ${
          !imageData.delivered ? 'delivered' : ''
        }`}
      >
        <div className='d-f-c-sb-center'>
          <Select
            style={{ width: 150, padding: '1rem 0' }}
            value={imageData.status}
            onChange={(value, option) => {
              this.handleImageStatusChange(value, imageData);
            }}
            disabled={imageData.delivered}
          >
            {_.map(Object.keys(IMAGE_STATUSES), (itemKey) => (
              <Option
                key={IMAGE_STATUSES[itemKey]}
                value={IMAGE_STATUSES[itemKey]}
              >
                {IMAGE_STATUSES[itemKey]}
              </Option>
            ))}
          </Select>
        </div>
      </div>
    );
  };

  renderImagePopover = (imageData, size, border = false) => {
    const imageLink = imageData && imageData.usageUrl;

    return (
      <div
        className='images-table-row'
        style={{ display: 'flex', justifyContent: 'space-around' }}
      >
        <div
          className='table-row__image'
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
            alignItems: 'center',
            marginRight: 10
          }}
        >
          <span>Uploaded</span>
          <img
            className='popover-image-search'
            alt=''
            src={`${imageData.originalImageFileName}?introlab`}
            style={{ border: border ? '1px solid beige' : '' }}
          />
        </div>
        <div
          className='table-row__image'
          style={{
            display: 'flex',
            justifyContent: 'space-around',
            flexDirection: 'column',
            alignItems: 'center'
          }}
        >
          <a
            target='_blank'
            href={imageLink}
            rel='nofollow noopener noreferrer'
          >
            <span>Online</span>
            <img
              className='popover-image-search'
              alt=''
              src={imageData.imageUrl}
              style={{ border: border ? '1px solid beige' : '' }}
            />
          </a>
        </div>
      </div>
    );
  };

  prepareImagesTableData = () => {
    const { getImagesByAgencyAndIdData } = this.props;

    let clonedTableData = _.cloneDeep(getImagesByAgencyAndIdData);
    clonedTableData.content = _.map(
      getImagesByAgencyAndIdData.content,
      (domainData) => {
        return _.merge({}, domainData, {
          country: this.renderImagesCountry(domainData),
          domainFlowStatus: this.renderFlowStatus(domainData),
          commercialIcon: this.renderImagesIcons(domainData.commercialWebSite),
          pursuableIcon: this.renderImagesIcons(!domainData.notPursuable),
          blacklistedIcon: this.renderImagesIcons(!domainData.blacklisted)
        });
      }
    );

    return clonedTableData;
  };

  prepareDomainTableData = () => {
    const { getDomainByNameData } = this.props;

    let clonedTableData = _.cloneDeep(getDomainByNameData);
    clonedTableData.content = _.map(
      getDomainByNameData.content,
      (domainData) => {
        return _.merge({}, domainData, {
          scrapedCountry: this.renderImagesNonCountry(domainData),
          country: this.renderImagesCountry(domainData),
          domainFlowStatus: this.renderFlowStatus(domainData),
          commercialIcon: this.renderImagesIcons(domainData.commercialWebSite),
          pursuableIcon: this.renderImagesIcons(!domainData.notPursuable),
          blacklistedIcon: this.renderImagesIcons(!domainData.blacklisted)
        });
      }
    );

    return clonedTableData;
  };

  prepareUsageUrlTableData = () => {
    const { getDomainsByUsageUrlData, getUsageUrlCountData } = this.props;

    let clonedTableData = _.cloneDeep(getDomainsByUsageUrlData);
    clonedTableData.content = _.map(
      getDomainsByUsageUrlData.content,
      (domainData) => {
        return _.merge({}, domainData, {
          scrapedCountry: this.renderImagesNonCountry(domainData),
          status: this.prepareUsageStatus(domainData),
          country: this.renderImagesCountry(domainData),
          imageUrl: this.renderImagePopover(domainData, true),
          pursuableIcon: this.renderImagesIcons(domainData.domainPursuable),
          blacklistedIcon: this.renderImagesIcons(!domainData.blacklisted)
        });
      }
    );

    if (getUsageUrlCountData.count || getUsageUrlCountData.count === 0) {
      clonedTableData = _.merge({}, clonedTableData, {
        usageUrlCount: getUsageUrlCountData.count
      });
    } else {
      clonedTableData = _.merge({}, clonedTableData, {
        usageUrlCountStatic: 125
      });
    }

    return clonedTableData;
  };

  prepareClickhouseUsageUrlTableData = () => {
    const { getDomainsByClickhouseUsageUrlData, getUsageUrlCountData } =
      this.props;

    let clonedTableData = _.cloneDeep(getDomainsByClickhouseUsageUrlData);
    clonedTableData.content = _.map(
      getDomainsByClickhouseUsageUrlData.content,
      (domainData) => {
        return _.merge({}, domainData, {
          scrapedCountry: this.renderImagesNonCountry(domainData),
          status: this.prepareUsageStatus(domainData),
          country: this.renderImagesCountry(domainData),
          imageUrl: this.renderImagePopover(domainData, true),
          pursuableIcon: this.renderImagesIcons(domainData.domainPursuable),
          blacklistedIcon: this.renderImagesIcons(!domainData.blacklisted)
        });
      }
    );

    if (getUsageUrlCountData.count || getUsageUrlCountData.count === 0) {
      clonedTableData = _.merge({}, clonedTableData, {
        usageUrlCount: getUsageUrlCountData.count
      });
    } else {
      clonedTableData = _.merge({}, clonedTableData, {
        usageUrlCountStatic: 125
      });
    }

    return clonedTableData;
  };

  prepareBlacklistedDomainTableData = () => {
    const { getBlacklistedDomainByNameData } = this.props;

    let clonedTableData = _.cloneDeep(getBlacklistedDomainByNameData);
    clonedTableData.content = _.map(
      getBlacklistedDomainByNameData.content,
      (domainData) => {
        return _.merge({}, domainData, {
          editButton: this.renderUserActions(domainData)
        });
      }
    );

    return clonedTableData;
  };

  renderDeleteButton = (domainData) => {
    const handleDelete = (e) => {
      e.stopPropagation();
      this.handleDeleteBlacklistedDomain(domainData);
    };

    return (
      <Tooltip
        placement='top'
        title='Delete domain'
        key={`delete_user_${domainData.id}`}
      >
        <Button icon='delete' onClick={(e) => handleDelete(e)} />
      </Tooltip>
    );
  };

  renderImagesCellCountry = (domainData) => {
    const country = domainData.country || null;

    if (country === null) {
      return '-';
    }

    if (Array.isArray(this.props.getCountriesListData)) {
      return this.props.getCountriesListData?.find(
        (obj) => obj.fullName.toLowerCase() === country.toLowerCase()
      );
    }

    return [];
  };

  renderImagesCellNonCountry = (domainData) => {
    const country = domainData.scrapedCountry || null;

    if (country === null) {
      return '-';
    }

    if (country !== null && country.indexOf('_') > -1) {
      const newArray = country.split('_');
      const newString = newArray.join(' ');

      if (Array.isArray(this.props.getCountriesListData)) {
        return this?.props.getCountriesListData?.find(
          (obj) => obj?.fullName.toLowerCase() === newString.toLowerCase()
        );
      }

      return [];
    }

    if (Array.isArray(this.props.getCountriesListData)) {
      return this.props?.getCountriesListData?.find(
        (obj) => obj?.fullName.toLowerCase() === country.toLowerCase()
      );
    }

    return [];
  };

  renderFlowCellStatus = (domainData) => {
    const status = domainData.domainFlowStatus;

    if (this.props?.getDomainFlowStatusesData)
      return this.props.getDomainFlowStatusesData?.find(
        (obj) => obj.fullName === status
      );

    return false;
  };

  renderImagesCellIcon = (value) => {
    if (value === null) {
      return '-';
    }

    if (value === true) {
      return (
        <Icon style={{ color: 'green' }} type='check-circle' theme='filled' />
      );
    }

    if (value === false) {
      return (
        <Icon style={{ color: 'red' }} type='close-circle' theme='filled' />
      );
    }
  };

  handleDeleteBlacklistedDomain = (domainData) => {
    this.setState(
      {
        isVisibleConfirm: true
      },
      () => {
        this.renderConfirmModal(domainData);
      }
    );
  };

  renderConfirmModal = (domainData) => {
    const { isVisibleConfirm } = this.state;

    return Modal.confirm({
      visible: isVisibleConfirm,
      title: 'Delete confirmation',
      content: `Are you sure, you want to delete "${domainData.domain}" domain from blacklist table`,
      keyboard: false,
      maskClosable: false,
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: () => this.handleAgree(domainData),
      onCancel: () => this.handleCancelDelete()
    });
  };

  handleAgree = (domainData) => {
    this.props.deleteDomainFromBlacklist(domainData.id).then(() => {
      if (!_.isEmpty(this.props.deleteDomainFromBlacklistDataErrorMessage)) {
        this.setState(
          {
            loaderIsVisible: false
          },
          () => {
            message.error(
              this.props.deleteDomainFromBlacklistDataErrorMessage.error,
              4
            );
          }
        );
      } else {
        this.setState(
          {
            isVisibleConfirm: false
          },
          () => {
            Modal.destroyAll();
            let paginationOptions = {
              page: this.state.blacklistedPaginationOptions.pageNumber - 1,
              size: this.state.blacklistedPaginationOptions.pageSize
            };
            message.success('Domain deleted successfully', 4);

            this.props.getBlacklistedDomainByName(
              this.state.blacklistedDomainSearchInput,
              paginationOptions,
              this.state.blacklistedTableSortedOption
            );

            if (!_.isEmpty(this.props.getBlacklistedDomainByNameErrorMessage)) {
              message.error(
                this.props.getBlacklistedDomainByNameErrorMessage.error,
                3
              );
            }
          }
        );
      }
    });
  };

  handleCancelDelete = () => {
    this.setState(
      {
        isVisibleConfirm: false
      },
      () => {
        Modal.destroyAll();
      }
    );
  };

  addNewDomainToBlacklist = () => {
    this.setState({
      showAddNewDomainModal: true
    });
  };

  domainSearchInputHandler = (e) => {
    this.setState({
      domainSearchInput: e.target.value
    });
  };

  usageUrlSearchInputHandler = (e) => {
    this.setState({
      usageUrlSearchInput: e.target.value
    });
  };

  usageClickhouseUrlSearchInputHandler = (e) => {
    this.setState({
      usageClickhouseUrlSearchInput: e.target.value
    });
  };

  blacklistedDomainSearchInputHandler = (e) => {
    this.setState({
      blacklistedDomainSearchInput: e.target.value
    });
  };

  domainSearchHandler = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const {
          ddomain,
          ddomain2,
          dcountry,
          dimagesCount,
          didenticalCount,
          dstatus,
          dscrapedCountry,
          dcommercial,
          dpursuable,
          dnotBlacklisted,
          dsocialDomain
        } = values;

        let paginationOptions = {
          page: 0,
          size: this.state.domainsPaginationOptions.pageSize
        };

        const domainHandler = () => {
          if (!_.isEmpty(ddomain2)) {
            const domain =
              `${ddomain.trim()}%${ddomain2.trim()}, ${ddomain2.trim()}%${ddomain.trim()}`.split(
                ', '
              );
            return domain;
          }
          if (!_.isEmpty(ddomain)) {
            return ddomain.trim().split(', ');
          } else return [];
        };

        let requestData = {
          domains: !_.isEmpty(ddomain) && domainHandler(),
          country: !_.isEmpty(dcountry) ? dcountry : '',
          scrapedCountry: !_.isEmpty(dscrapedCountry) ? dscrapedCountry : '',
          imagesCount: !_.isEmpty(dimagesCount) ? dimagesCount : null,
          identicalCount: !_.isEmpty(didenticalCount) ? didenticalCount : null,
          status: !_.isEmpty(dstatus) ? dstatus : '',
          commercial: this.convertToBool(dcommercial),
          pursuable: this.convertToBool(dpursuable),
          notBlacklisted: this.convertToBool(dnotBlacklisted),
          socialDomain: this.convertToBool(dsocialDomain)
        };

        if (!ddomain && !ddomain2) {
          message.error('Search value can not be empty!');
          return;
        }

        if (!ddomain) {
          return;
        }

        this.setState({
          loaderIsVisible: true,
          domainsPaginationOptions: {
            pageNumber: 1,
            pageSize: 10
          }
        });

        Promise.resolve(
          this.props.getDomainByName(requestData, paginationOptions)
        ).then(() => this.setState({ loaderIsVisible: false }));
      }
    });
  };

  imagesFormSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const {
          agency,
          imageId,
          domain,
          country,
          imagesCount,
          identicalCount,
          identicalSightingsById,
          sightingsById,
          status,
          commercial,
          pursuable,
          notBlacklisted
        } = values;

        let paginationOptions = {
          page: 0,
          size: this.state.imagesPaginationOptions.pageSize
        };

        let requestData = {
          agency: !_.isEmpty(agency) ? agency : '',
          imageId: !_.isEmpty(imageId) ? imageId : '',
          domains: !_.isEmpty(domain) ? domain.split(', ') : [],
          country: !_.isEmpty(country) ? country : '',
          imagesCount: !_.isEmpty(imagesCount) ? imagesCount : null,
          identicalCount: !_.isEmpty(identicalCount) ? identicalCount : null,
          searchedImageCount: !_.isEmpty(sightingsById) ? sightingsById : null,
          searchedImageIdenticalCount: !_.isEmpty(identicalSightingsById)
            ? identicalSightingsById
            : null,
          status: !_.isEmpty(status) ? status : '',
          commercial: this.convertToBool(commercial),
          pursuable: this.convertToBool(pursuable),
          notBlacklisted: this.convertToBool(notBlacklisted)
        };

        if (!agency && !imageId) {
          message.error('Search values can not be empty!');
          return;
        }

        // if (agency.trim() || imageId.trim()) {
        this.setState({
          loaderIsVisible: true,
          imagesPaginationOptions: {
            pageNumber: 1,
            pageSize: 10
          }
        });

        Promise.resolve(
          this.props.getImagesByAgencyAndId(requestData, paginationOptions)
        ).then(() => this.setState({ loaderIsVisible: false }));
        // }
      }
    });
  };

  usageUrlFormSubmit = (e) => {
    if (e) e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { usageUrl, usageRadio } = values;
        const { sightingsFilters, usagesUrlSelectFilters } = this.state;

        let paginationOptions = {
          page: 0,
          size: this.state.usageUrlPaginationOptions.pageSize
        };

        const usageUrlPart = !_.isEmpty(sightingsFilters.usageUrl.value)
          ? sightingsFilters.usageUrl.value
          : null;

        const isNullBlacklised =
          _.isNull(usagesUrlSelectFilters.blacklisted) ||
          usagesUrlSelectFilters.blacklisted === 'null';

        const requestData = {
          part: usageRadio === 'usagePart' ? usageUrl : null,
          domainPart: usageRadio === 'usagePartDomain' ? usageUrl : null,
          sourcePart: usageRadio === 'usagePartSource' ? usageUrl : null,
          socialNetwork: this.state.socialNetwork,
          domainExactSearch: this.state.exactMatches,
          imageIdExactSearch: this.state.imageIdExactSearch,
          facebook: this.state.facebook ? this.state.facebook : null,
          facebookNotDefined: this.state.facebookNotDefined
            ? this.state.facebookNotDefined
            : null,
          partForFilter: usageUrlPart,
          status: !_.isEmpty(sightingsFilters.imageStatus.value)
            ? [...sightingsFilters.imageStatus.value]
            : null,
          agency: !_.isEmpty(sightingsFilters.agencyId.value)
            ? [...sightingsFilters.agencyId.value]
            : null,
          imageId: !_.isEmpty(sightingsFilters.imageId.value)
            ? sightingsFilters.imageId.value
            : null,
          imageUrl: !_.isEmpty(sightingsFilters.imageUrl.value)
            ? sightingsFilters.imageUrl.value
            : null,
          domain: !_.isEmpty(sightingsFilters.domain.value)
            ? sightingsFilters.domain.value
            : null,
          pursuable: usagesUrlSelectFilters.pursuable,
          differenceStart: !_.isEmpty(
            sightingsFilters.difference?.differenceStart
          )
            ? sightingsFilters.difference?.differenceStart
            : null,
          differenceEnd: !_.isEmpty(sightingsFilters.difference?.differenceEnd)
            ? sightingsFilters.difference?.differenceEnd
            : null,
          foundAtStart: !_.isEmpty(sightingsFilters.dates.foundAtStart)
            ? sightingsFilters.dates.foundAtStart
            : null,
          foundAtEnd: !_.isEmpty(sightingsFilters.dates.foundAtEnd)
            ? sightingsFilters.dates.foundAtEnd
            : null,
          blacklisted: isNullBlacklised
            ? null
            : !this.convertToBool(usagesUrlSelectFilters.blacklisted),
          country: this.state.undefineCountry
            ? ['UNDEFINED']
            : !_.isEmpty(sightingsFilters.country.value)
            ? [...sightingsFilters.country.value]
            : null,
          scrapedCountry: this.state.undefineNonCountry
            ? ['UNDEFINED']
            : !_.isEmpty(sightingsFilters.scrapedCountry.value)
            ? [...sightingsFilters.scrapedCountry.value]
            : null,
          registeredImage: this.state.copyright
        };

        const sortingOptions = {
          status: sightingsFilters.imageStatus.order,
          agency: sightingsFilters.agencyId.order,
          imageId: sightingsFilters.imageId.order,
          imageUrl: sightingsFilters.imageUrl.order,
          domain: sightingsFilters.domain.order,
          usageUrl: sightingsFilters.usageUrl.order,
          country: sightingsFilters.country.order,
          scrapedCountry: sightingsFilters.scrapedCountry.order,
          difference: sightingsFilters.difference.order,
          // foundAt: sightingsFilters.dates.order
          foundAt: sightingsFilters.dates.order
            ? sightingsFilters.dates.order
            : 'desc'
        };

        // if (!usageUrl || !usageRadio) {
        //   message.error('Search values can not be empty!');
        //   return;
        // }

        // if (usageUrl.trim().length < 3) {
        //   message.error('Search value should be at least 3 symbols!');
        //   return;
        // }

        this.setState({
          loaderIsVisible: true,
          usageUrlPaginationOptions: {
            pageNumber: 1,
            pageSize: 1000
          }
        });

        Promise.resolve(
          this.props.getDomainsByUsageUrl(
            requestData,
            paginationOptions,
            sortingOptions
          )
        )
          .then(() => {
            this.setState({ loaderIsVisible: false });
          })
          .then(() => {
            if (this.props.getDomainsByUsageUrlErrorMessage) {
              this.setState({ visibleUsageError: true });
            }

            if (this.props.getDomainsByUsageUrlData.countId) {
              // if (!this.props.getDomainsByUsageUrlData.count) return;

              this.props.getUsageUrlCount(
                this.props.getDomainsByUsageUrlData.countId
              );
              const timer = setInterval(() => {
                if (!this.props.getUsageUrlCountData.count) {
                  this.props.getUsageUrlCount(
                    this.props.getDomainsByUsageUrlData.countId
                  );
                } else {
                  clearInterval(timer);
                }
              }, 5000);
            }
          });
      }
    });
  };

  /* @CLICKHOUSE SEARCH TAB ----------------------------------------------------------------------------------------------------------- */

  // Searh Function for Clickhouse Tab
  usageClickhouseUrlFormSubmit = (e, isResetRequest, filters) => {
    if (e) e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        let requestFunction = null;

        if (this.state.arciveSearch)
          requestFunction = this.props.getDomainsByClickhouseArchiveUsageUrl;
        else requestFunction = this.props.getDomainsByClickhouseUsageUrl;

        const { clickhouseUsageUrl, usageClickhouseRadio } = values;
        const { sightingsClickhouseFilters, usagesClickhouseUrlSelectFilters } =
          this.state;

        let currentFilters = isResetRequest
          ? filters
          : sightingsClickhouseFilters;

        let paginationOptions = {
          page: 0,
          size: this.state.usageUrlPaginationOptions.pageSize
        };

        const usageUrlPart = !_.isEmpty(currentFilters.usageUrl.value)
          ? currentFilters.usageUrl.value
          : null;

        const isNullBlacklised =
          _.isNull(usagesClickhouseUrlSelectFilters.blacklisted) ||
          usagesClickhouseUrlSelectFilters.blacklisted === 'null';

        const requestData = {
          part:
            usageClickhouseRadio === 'usagePart' ? clickhouseUsageUrl : null,
          domainPart:
            usageClickhouseRadio === 'usagePartDomain'
              ? clickhouseUsageUrl
              : null,
          sourcePart:
            usageClickhouseRadio === 'usagePartSource'
              ? clickhouseUsageUrl
              : null,
          socialNetwork: this.state.socialNetwork,
          domainExactSearch: this.state.exactMatchesClickhouse,
          imageIdExactSearch: this.state.imageIdExactSearch,
          facebook: this.state.clickhouseFacebook
            ? this.state.clickhouseFacebook
            : null,
          facebookNotDefined: this.state.clickhouseFacebookNotDefined
            ? this.state.clickhouseFacebookNotDefined
            : null,
          partForFilter: usageUrlPart,
          status: !_.isEmpty(currentFilters.imageStatus.value)
            ? [...currentFilters.imageStatus.value]
            : null,
          agency: !_.isEmpty(currentFilters.agencyId.value)
            ? [...currentFilters.agencyId.value]
            : null,
          imageId: !_.isEmpty(currentFilters.imageId.value)
            ? currentFilters.imageId.value
            : null,
          imageUrl: !_.isEmpty(currentFilters.imageUrl.value)
            ? currentFilters.imageUrl.value
            : null,
          domain: !_.isEmpty(currentFilters.domain.value)
            ? currentFilters.domain.value
            : null,
          pursuable: usagesClickhouseUrlSelectFilters.pursuable,
          differenceStart: !_.isEmpty(
            currentFilters.difference?.differenceStart
          )
            ? currentFilters.difference?.differenceStart
            : null,
          differenceEnd: !_.isEmpty(currentFilters.difference?.differenceEnd)
            ? currentFilters.difference?.differenceEnd
            : null,
          foundAtStart: !_.isEmpty(currentFilters.dates.foundAtStart)
            ? currentFilters.dates.foundAtStart
            : null,
          foundAtEnd: !_.isEmpty(currentFilters.dates.foundAtEnd)
            ? currentFilters.dates.foundAtEnd
            : null,
          blacklisted: isNullBlacklised
            ? null
            : !this.convertToBool(usagesClickhouseUrlSelectFilters.blacklisted),
          country: this.state.undefineCountryClickhouse
            ? ['UNDEFINED']
            : !_.isEmpty(currentFilters.country.value)
            ? [...currentFilters.country.value]
            : null,
          scrapedCountry: this.state.undefineNonCountryClickhouse
            ? ['UNDEFINED']
            : !_.isEmpty(currentFilters.scrapedCountry.value)
            ? [...currentFilters.scrapedCountry.value]
            : null,
          registeredImage: this.state.copyrightClickhouse
        };

        const sortingOptions = {
          status: currentFilters.imageStatus.order,
          agency: currentFilters.agencyId.order,
          imageId: currentFilters.imageId.order,
          imageUrl: currentFilters.imageUrl.order,
          domain: currentFilters.domain.order,
          usageUrl: currentFilters.usageUrl.order,
          country: currentFilters.country.order,
          scrapedCountry: currentFilters.scrapedCountry.order,
          difference: currentFilters.difference.order,
          // foundAt: sightingsFilters.dates.order
          foundAt: currentFilters.dates.order
            ? currentFilters.dates.order
            : 'desc'
        };

        this.setState({
          loaderIsVisible: true,
          usageClickhouseUrlPaginationOptions: {
            pageNumber: 1,
            pageSize: 1000
          }
        });

        Promise.resolve(
          requestFunction(requestData, paginationOptions, sortingOptions)
        )
          .then(() => {
            this.setState({ loaderIsVisible: false });
          })
          .then(() => {
            if (this.props.getDomainsByClickhouseUsageUrlErrorMessage) {
              this.setState({ visibleUsageError: true });
            }

            if (this.props.getDomainsByClickhouseUsageUrlData?.countId) {
              // if (!this.props.getDomainsByUsageUrlData.count) return;

              this.props.getUsageUrlCount(
                this.props.getDomainsByClickhouseUsageUrlData?.countId
              );
              const timer = setInterval(() => {
                if (!this.props.getUsageUrlCountData.count) {
                  this.props.getUsageUrlCount(
                    this.props.getDomainsByClickhouseUsageUrlData.countId
                  );
                } else {
                  clearInterval(timer);
                }
              }, 5000);
            }
          });
      }
    });
  };

  // Reset For Clickhouse
  resetClickhouseSightingsFilter = () => {
    const resetFilters = {
      sightingsClickhouseFilters: {
        imageStatus: { order: '' },
        agencyId: { order: '' },
        imageId: { order: '' },
        usageUrl: { order: '' },
        imageUrl: { order: '' },
        domain: { order: '' },
        country: { order: '' },
        scrapedCountry: { order: '' },
        difference: { order: '' },
        scrappedCountries: { order: '' },
        dates: { order: '' }
      },
      usagesClickhouseUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      }
    };

    this.setState(resetFilters);

    this.usageClickhouseUrlFormSubmit(
      null,
      true,
      resetFilters.sightingsClickhouseFilters
    );
  };

  /* --------------------------------------------------------------------------------------------------------------------------------- */

  blacklistedDomainSearchHandler = (e) => {
    e.preventDefault();
    const domain = this.state.blacklistedDomainSearchInput;

    let paginationOptions = {
      page: 0,
      size: this.state.blacklistedPaginationOptions.pageSize
    };

    if (domain.trim()) {
      this.setState({
        loaderIsVisible: true,
        blacklistedPaginationOptions: {
          pageNumber: 1,
          pageSize: 10
        }
      });

      Promise.resolve(
        this.props.getBlacklistedDomainByName(domain, paginationOptions)
      ).then(() => this.setState({ loaderIsVisible: false }));
    } else {
      message.error('Search value can not be empty!');
    }
  };

  imagesAgencyFieldHandler = (value) => {
    this.setState({
      imagesAgency: value
    });
  };

  imagesAgencyIdFieldHandler = (e) => {
    this.setState({
      imagesAgencyId: e.target.value
    });
  };

  autoSize = (e) => {
    const el = e.target;
    setTimeout(() => {
      el.style.cssText = 'height:32px; padding:0';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    }, 0);
  };

  onSelectChange = (selectedRowKeys, row) => {
    this.setState({
      selectedImagesIds: row,
      selectedRowKeys
    });
  };

  onUsageUrlErrorClose = () => {
    this.setState({ visibleUsageError: false });
  };

  resetSightingsFilter = () => {
    this.setState({
      sightingsFilters: {
        imageStatus: { order: '' },
        agencyId: { order: '' },
        imageId: { order: '' },
        usageUrl: { order: '' },
        imageUrl: { order: '' },
        domain: { order: '' },
        country: { order: '' },
        scrapedCountry: { order: '' },
        difference: { order: '' },
        scrappedCountries: { order: '' },
        dates: { order: '' }
      },
      usagesUrlSelectFilters: {
        pursuable: null,
        blacklisted: null
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onSelectChange
    };
    const antIcon = <Icon type='loading' style={{ fontSize: 24 }} spin />;

    return (
      <Spin size='large' spinning={this.state.loaderIsVisible}>
        <Modal
          visible={this.state.visibleUsageError}
          onOk={this.onUsageUrlErrorClose}
          onCancel={() => {}}
          okButtonProps={{
            children: 'OK'
          }}
          cancelButtonProps={{ style: { display: 'none' } }}
        >
          <p>{this.props.getDomainsByUsageUrlErrorMessage}</p>
        </Modal>

        <div className='Search ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
          <BackTop>
            <div className='ant-back-top-inner'>
              <Icon type='vertical-align-top' />
            </div>
          </BackTop>
          <Tabs defaultActiveKey={this.state.defaultTabKey}>
            {this.props.userInfo.userPermissions?.tablePermission && (
              <TabPane tab='Images table' key='images'>
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-10'>
                  <Form onSubmit={this.imagesFormSubmit}>
                    <Row
                      style={{
                        display: 'flex',
                        marginBottom: '1rem'
                      }}
                    >
                      <Col
                        style={{
                          width: '20%',
                          marginRight: '10px'
                        }}
                      >
                        <Form.Item style={{ marginBottom: 0 }}>
                          {getFieldDecorator('agency')(
                            <Select
                              showSearch
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .startsWith(input.toLowerCase())
                              }
                              allowClear
                              placeholder='Please enter agency ID'
                              onChange={(value) =>
                                this.imagesAgencyFieldHandler(value)
                              }
                            >
                              {_.map(
                                this.props.getImagesTableAgenciesData,
                                (agency) => (
                                  <Option key={agency} value={agency}>
                                    {agency}
                                  </Option>
                                )
                              )}
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          width: '30%',
                          marginRight: '10px'
                        }}
                      >
                        <Form.Item style={{ marginBottom: 0 }}>
                          {getFieldDecorator('imageId')(
                            <Input
                              onChange={this.imagesAgencyIdFieldHandler}
                              placeholder='Please enter image ID'
                            />
                          )}
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            marginRight: '1rem'
                          }}
                        >
                          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                            <Button type='primary' htmlType='submit'>
                              Search
                            </Button>
                          </div>
                        </Form.Item>
                        {this.props.getImagesByAgencyAndIdData.hasOwnProperty(
                          'totalCount'
                        ) &&
                          this.props.getImagesByAgencyAndIdData.totalCount >
                            0 && (
                            <span>
                              Total{' '}
                              <b>
                                {
                                  this.props.getImagesByAgencyAndIdData
                                    .totalCount
                                }
                              </b>{' '}
                              {this.props.getImagesByAgencyAndIdData
                                .totalCount > 1
                                ? 'items'
                                : 'item'}
                            </span>
                          )}
                      </Col>
                    </Row>
                    {this.props.getImagesByAgencyAndIdData.hasOwnProperty(
                      'content'
                    ) && (
                      <Row
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          margin: 0
                        }}
                      >
                        <div
                          style={{
                            width: '12%',
                            paddingRight: '3px',
                            paddingLeft: '6px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('domain')(<Search />)}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '11%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('country')(
                              <Select
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .startsWith(input.toLowerCase())
                                }
                              >
                                {_.map(
                                  this.props.getCountriesListData,
                                  (obj) => (
                                    <Option
                                      key={obj.fullName}
                                      value={obj.fullName}
                                    >
                                      {obj.fullName}
                                    </Option>
                                  )
                                )}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '9%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('imagesCount')(<Search />)}
                        </div>
                        <div
                          style={{
                            width: '9%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('identicalCount')(<Search />)}
                        </div>
                        <div
                          style={{
                            width: '9%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('sightingsById')(<Search />)}
                        </div>
                        <div
                          style={{
                            width: '11%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('identicalSightingsById')(
                            <Search />
                          )}
                        </div>
                        <div
                          style={{
                            width: '10%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('status')(
                            <Select allowClear>
                              {_.map(
                                this.props.getDomainFlowStatusesData,
                                (obj) => (
                                  <Option
                                    key={obj.shortName}
                                    value={obj.fullName}
                                  >
                                    <Tooltip title={obj.fullName}>
                                      {obj.shortName}
                                    </Tooltip>
                                  </Option>
                                )
                              )}
                            </Select>
                          )}
                        </div>
                        <div
                          style={{
                            width: '10%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('commercial', {
                              initialValue: 'all'
                            })(
                              <Select
                                style={{
                                  width: '100%'
                                }}
                              >
                                <Option key='all' value='all'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '9%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('pursuable', {
                              initialValue: 'all'
                            })(
                              <Select
                                style={{
                                  width: '100%'
                                }}
                              >
                                <Option key='all' value='all'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '10%',
                            paddingRight: '6px',
                            paddingLeft: '3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('notBlacklisted', {
                              initialValue: 'all'
                            })(
                              <Select
                                style={{
                                  width: '100%'
                                }}
                              >
                                <Option key='all' value='all'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </Row>
                    )}
                  </Form>
                </div>
                {this.props.getImagesByAgencyAndIdData.hasOwnProperty(
                  'content'
                ) && (
                  <div className='search-tab ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                    <TableComponent
                      tableFor='images'
                      tableColumns={IMAGES_TABLE_COLUMNS}
                      tableData={this.prepareImagesTableData()}
                      paginationOptions={this.state.imagesPaginationOptions}
                      selectedFiltersFields={this.state.selectedImagesFields}
                      onChangePagination={this.handleTablePaginationChange}
                      handleChangeColumnSort={this.handleColumnSortChange}
                      sortingOptions={this.state.imagesTableSortedOption}
                      redirectPermission={
                        this.props.userInfo.userPermissions?.reviewPermission
                      }
                    />
                  </div>
                )}
              </TabPane>
            )}
            {this.props.userInfo.userPermissions?.tablePermission && (
              <TabPane tab='Domains table' key='domains'>
                {/* <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'> */}
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-10'>
                  <Form onSubmit={this.domainSearchHandler}>
                    <Row
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '1rem'
                      }}
                    >
                      <Col
                        style={{
                          width: '45%',
                          marginRight: '10px'
                        }}
                      >
                        <Form.Item style={{ marginBottom: 0 }}>
                          {getFieldDecorator('ddomain')(
                            // <Input
                            //   onChange={this.domainSearchInputHandler}
                            //   placeholder='Type in a domain name'
                            // />
                            <TextArea
                              style={{ height: '32px', overflow: 'hidden' }}
                              rows={2}
                              placeholder='Please enter domain name'
                              onChange={this.domainSearchInputHandler}
                              onKeyDown={this.autoSize}
                            ></TextArea>
                          )}
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            marginRight: '1rem'
                          }}
                        >
                          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                            <Button type='primary' htmlType='submit'>
                              Search
                            </Button>
                          </div>
                        </Form.Item>
                        {this.props.getDomainByNameData.hasOwnProperty(
                          'totalCount'
                        ) &&
                          this.props.getDomainByNameData.totalCount > 0 && (
                            <span>
                              Total{' '}
                              <b>{this.props.getDomainByNameData.totalCount}</b>{' '}
                              {this.props.getDomainByNameData.totalCount > 1
                                ? 'items'
                                : 'item'}
                            </span>
                          )}
                      </Col>
                    </Row>
                    <Row
                      style={{
                        display: 'flex',
                        marginBottom: '1rem'
                      }}
                    >
                      <Form.Item style={{ marginBottom: 0 }}>
                        {getFieldDecorator('dsocialDomain', {
                          initialValue: 'all'
                        })(
                          <Radio.Group>
                            <Radio value='all' style={{ marginRight: '1rem' }}>
                              All
                            </Radio>
                            <Radio value='true' style={{ marginRight: '1rem' }}>
                              Facebook
                            </Radio>
                            <Radio
                              value='false'
                              style={{ marginRight: '1rem' }}
                            >
                              No Facebook
                            </Radio>
                          </Radio.Group>
                        )}
                      </Form.Item>
                    </Row>
                    {this.props.getDomainByNameData.hasOwnProperty(
                      'content'
                    ) && (
                      <Row
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          margin: 0
                        }}
                      >
                        <div
                          style={{
                            width: '15%',
                            paddingRight: '3px',
                            paddingLeft: '6px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('ddomain2')(<Search />)}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '15%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('dcountry')(
                              <Select
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .startsWith(input.toLowerCase())
                                }
                              >
                                {_.map(
                                  this.props.getCountriesListData,
                                  (obj) => (
                                    <Option
                                      key={obj.fullName}
                                      value={obj.fullName}
                                    >
                                      {obj.fullName}
                                    </Option>
                                  )
                                )}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '15%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('dscrapedCountry')(
                              <Select
                                allowClear
                                showSearch
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .startsWith(input.toLowerCase())
                                }
                              >
                                {_.map(
                                  this.props.getCountriesListData,
                                  (obj) => (
                                    <Option
                                      key={obj.fullName}
                                      value={obj.fullName}
                                    >
                                      {obj.fullName}
                                    </Option>
                                  )
                                )}
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '10%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('dimagesCount')(<Search />)}
                        </div>
                        <div
                          style={{
                            width: '10%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('didenticalCount')(<Search />)}
                        </div>
                        <div
                          style={{
                            width: '15%',
                            padding: '0 3px'
                          }}
                        >
                          {getFieldDecorator('dstatus')(
                            <Select allowClear>
                              {_.map(
                                this.props.getDomainFlowStatusesData,
                                (obj) => (
                                  <Option
                                    key={obj.shortName}
                                    value={obj.fullName}
                                  >
                                    <Tooltip title={obj.fullName}>
                                      {obj.shortName}
                                    </Tooltip>
                                  </Option>
                                )
                              )}
                            </Select>
                          )}
                        </div>
                        <div
                          style={{
                            width: '12%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('dcommercial', {
                              initialValue: 'all'
                            })(
                              <Select
                                style={{
                                  width: '100%'
                                }}
                              >
                                <Option key='all' value='all'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '11%',
                            padding: '0 3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('dpursuable', {
                              initialValue: 'all'
                            })(
                              <Select
                                style={{
                                  width: '100%'
                                }}
                              >
                                <Option key='all' value='all'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                        <div
                          style={{
                            width: '12%',
                            paddingRight: '6px',
                            paddingLeft: '3px'
                          }}
                        >
                          <Form.Item>
                            {getFieldDecorator('dnotBlacklisted', {
                              initialValue: 'all'
                            })(
                              <Select
                                style={{
                                  width: '100%'
                                }}
                              >
                                <Option key='all' value='all'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            )}
                          </Form.Item>
                        </div>
                      </Row>
                    )}
                  </Form>
                </div>
                {this.props.getDomainByNameData.hasOwnProperty('content') && (
                  <div className='search-tab ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                    <TableComponent
                      noDataMsg='No data for this domain'
                      tableFor='domains'
                      tableColumns={DOMAINS_TABLE_COLUMNS}
                      tableData={this.prepareDomainTableData()}
                      paginationOptions={this.state.domainsPaginationOptions}
                      selectedFiltersFields={this.state.selectedDomainsFields}
                      onChangePagination={this.handleTablePaginationChange}
                      handleChangeColumnSort={this.handleColumnSortChange}
                      sortingOptions={this.state.domainsTableSortedOption}
                      redirectPermission={
                        this.props.userInfo.userPermissions?.reviewPermission
                      }
                    />
                  </div>
                )}
              </TabPane>
            )}
            {console.log('filters', this.state.sightingsFilters)}
            {this.props.userInfo.userPermissions?.tablePermission && (
              <TabPane tab='Usages URL' key='usageUrl'>
                {/* <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'> */}
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-10'>
                  <Form onSubmit={this.usageUrlFormSubmit}>
                    <Row
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '.5rem'
                      }}
                    >
                      <Col
                        style={{
                          width: '45%',
                          marginRight: '10px'
                        }}
                      >
                        <Form.Item style={{ marginBottom: 0 }}>
                          {getFieldDecorator('usageUrl')(
                            <TextArea
                              style={{ height: '32px', overflow: 'hidden' }}
                              rows={2}
                              placeholder='Please enter usage url'
                              onChange={this.usageUrlSearchInputHandler}
                              onKeyDown={this.autoSize}
                            ></TextArea>
                          )}
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            marginRight: '1rem'
                          }}
                        >
                          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                            <Button type='primary' htmlType='submit'>
                              Search
                            </Button>
                          </div>
                        </Form.Item>

                        {this.props.getUsageUrlCountData.hasOwnProperty(
                          'count'
                        ) &&
                          this.props.getUsageUrlCountData.count === null && (
                            <>
                              <span style={{ marginRight: '1rem' }}>Total</span>
                              <Spin indicator={antIcon} />
                            </>
                          )}

                        {this.props.getUsageUrlCountData.hasOwnProperty(
                          'count'
                        ) &&
                          this.props.getUsageUrlCountData.count > -1 &&
                          this.props.getDomainsByUsageUrlData.count > 0 && (
                            <span>
                              Total{' '}
                              <b>{this.props.getUsageUrlCountData.count}</b>{' '}
                              {this.props.getUsageUrlCountData.count > 1
                                ? 'items'
                                : 'item'}
                            </span>
                          )}
                      </Col>
                    </Row>
                    <Row
                      style={{
                        display: 'flex',
                        marginBottom: '1rem',
                        width: '45%',
                        alignItems: 'center'
                      }}
                    >
                      <Form.Item style={{ marginBottom: 0 }}>
                        {getFieldDecorator('usageRadio', {
                          initialValue: 'usagePart'
                        })(
                          <Radio.Group>
                            <Radio
                              value='usagePart'
                              style={{ marginRight: '1rem' }}
                            >
                              All
                            </Radio>
                            <Radio
                              value='usagePartDomain'
                              style={{ marginRight: '1rem' }}
                            >
                              Within domain
                            </Radio>
                            <Radio
                              value='usagePartSource'
                              style={{ marginRight: '1rem' }}
                            >
                              Without domain
                            </Radio>
                          </Radio.Group>
                        )}
                      </Form.Item>

                      <div style={{ marginLeft: 'auto' }}>
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ facebook: true });
                            } else {
                              this.setState({ facebook: false });
                            }
                          }}
                          checked={this.state.facebook}
                        >
                          Facebook
                        </Checkbox>
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ facebookNotDefined: true });
                            } else {
                              this.setState({ facebookNotDefined: false });
                            }
                          }}
                          checked={this.state.facebookNotDefined}
                        >
                          Facebook not defined
                        </Checkbox>
                      </div>
                    </Row>
                  </Form>
                </div>
                <div className='search-tab-usages ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                  <Row
                    style={{
                      paddingTop: '2rem'
                    }}
                  >
                    <div className='ant-col-xs-24'>
                      <div className='filter-fields'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%'
                          }}
                        >
                          <Button
                            type='primary'
                            onClick={() => this.resetSightingsFilter()}
                            style={{ width: '84px' }}
                          >
                            Reset
                          </Button>
                          <ImageStatus
                            params={this.state.sightingsFilters.imageStatus}
                            statuses={Object.values(IMAGE_STATUSES)}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  imageStatus: filter
                                }
                              })
                            }
                          />
                          <AgencyId
                            params={this.state.sightingsFilters?.agencyId}
                            agencies={this.props.getImagesTableAgenciesData}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  agencyId: filter
                                }
                              })
                            }
                            setIsCopyright={(state) =>
                              this.setState({
                                copyright: state
                              })
                            }
                            isCopyright={this.state.copyright}
                          />
                          <Country
                            params={this.state.sightingsFilters.country}
                            countries={this.props.getCountriesListData}
                            isUndefineCountry={this.state.undefineCountry}
                            onChangeDefine={(state) => {
                              if (state.target.value === 'undefineCountry') {
                                this.setState({
                                  undefineCountry: true
                                });
                              } else {
                                this.setState({
                                  undefineCountry: false
                                });
                              }
                            }}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  country: filter
                                }
                              })
                            }
                          />
                          <NonVerifiedCountry
                            params={this.state.sightingsFilters.scrapedCountry}
                            countries={this.props.getCountriesListData}
                            isUndefineCountry={this.state.undefineNonCountry}
                            onChangeDefine={(state) => {
                              if (state.target.value === 'undefineNonCountry') {
                                this.setState({
                                  undefineNonCountry: true
                                });
                              } else {
                                this.setState({
                                  undefineNonCountry: false
                                });
                              }
                            }}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  scrapedCountry: filter
                                }
                              })
                            }
                          />
                          <ImageId
                            params={this.state.sightingsFilters.imageId}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  imageId: filter
                                }
                              })
                            }
                          />
                          <ImageUrl
                            params={this.state.sightingsFilters.imageUrl}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  imageUrl: filter
                                }
                              })
                            }
                          />
                          <Domain
                            params={this.state.sightingsFilters.domain}
                            exact={this.state.exactMatches}
                            onChangeExact={(state) =>
                              this.setState({
                                exactMatches: state
                              })
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  domain: filter
                                }
                              })
                            }
                          />
                          <UsageUrl
                            params={this.state.sightingsFilters.usageUrl}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  usageUrl: filter
                                }
                              })
                            }
                          />
                          <FoundAtFilter
                            params={this.state.sightingsFilters.dates}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  dates: filter
                                }
                              })
                            }
                          />
                          <DifferenceFilter
                            params={this.state.sightingsFilters.difference}
                            onChange={(filter) =>
                              this.setState({
                                sightingsFilters: {
                                  ...this.state.sightingsFilters,
                                  difference: filter
                                }
                              })
                            }
                          />
                          <div
                            style={{
                              width: '4%',
                              padding: '0 3px'
                            }}
                          >
                            <Form.Item>
                              <Select
                                style={{
                                  width: '100%'
                                }}
                                defaultValue='null'
                                value={String(
                                  this.state.usagesUrlSelectFilters.pursuable
                                )}
                                onChange={(value) =>
                                  this.setState({
                                    usagesUrlSelectFilters: {
                                      ...this.state.usagesUrlSelectFilters,
                                      pursuable: value
                                    }
                                  })
                                }
                              >
                                <Option key='all' value='null'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                          <div
                            style={{
                              width: '4%',
                              paddingRight: '6px',
                              paddingLeft: '3px'
                            }}
                          >
                            <Form.Item>
                              <Select
                                style={{
                                  width: '100%'
                                }}
                                defaultValue='null'
                                value={String(
                                  this.state.usagesUrlSelectFilters.blacklisted
                                )}
                                onChange={(value) =>
                                  this.setState({
                                    usagesUrlSelectFilters: {
                                      ...this.state.usagesUrlSelectFilters,
                                      blacklisted: value
                                    }
                                  })
                                }
                              >
                                <Option key='all' value='null'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                  {this.props.getDomainsByUsageUrlData.hasOwnProperty(
                    'content'
                  ) && (
                    <UsageUrlTable
                      noDataMsg='No data for this domain'
                      tableFor='usageUrl'
                      tableColumns={USAGE_URL_TABLE_COLUMNS}
                      tableData={this.prepareUsageUrlTableData()}
                      paginationOptions={this.state.usageUrlPaginationOptions}
                      selectedFiltersFields={this.state.selectedDomainsFields}
                      onChangePagination={this.handleTablePaginationChange}
                      handleChangeColumnSort={this.handleColumnSortChange}
                      sortingOptions={this.state.usageUrlTableSortedOption}
                      redirectPermission={
                        this.props.userInfo.userPermissions?.reviewPermission
                      }
                      rowSelection={rowSelection}
                    />
                  )}
                </div>
              </TabPane>
            )}
            {/*  Clickhouse Tab */}
            {this.props.userInfo.userPermissions?.tablePermission && (
              <TabPane tab='Clickhouse Usage url' key='clickhouseUsageUrl'>
                {/* <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'> */}
                <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-10'>
                  <Form onSubmit={this.usageClickhouseUrlFormSubmit}>
                    <Row
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start',
                        marginBottom: '.5rem'
                      }}
                    >
                      <Col
                        style={{
                          width: '45%',
                          marginRight: '10px'
                        }}
                      >
                        <Form.Item style={{ marginBottom: 0 }}>
                          {getFieldDecorator('clickhouseUsageUrl')(
                            <TextArea
                              style={{ height: '32px', overflow: 'hidden' }}
                              rows={2}
                              placeholder='Please enter usage url'
                              onChange={
                                this.usageClickhouseUrlSearchInputHandler
                              }
                              onKeyDown={this.autoSize}
                            ></TextArea>
                          )}
                        </Form.Item>
                      </Col>
                      <Col
                        style={{
                          display: 'flex',
                          alignItems: 'center'
                        }}
                      >
                        <Form.Item
                          style={{
                            marginBottom: 0,
                            marginRight: '1rem'
                          }}
                        >
                          <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                            <Button type='primary' htmlType='submit'>
                              Search
                            </Button>
                          </div>
                        </Form.Item>

                        {this.props.getUsageUrlCountData.hasOwnProperty(
                          'count'
                        ) &&
                          this.props.getUsageUrlCountData.count === null && (
                            <>
                              <span style={{ marginRight: '1rem' }}>Total</span>
                              <Spin indicator={antIcon} />
                            </>
                          )}

                        {this.props.getUsageUrlCountData.hasOwnProperty(
                          'count'
                        ) &&
                          this.props.getUsageUrlCountData.count > -1 &&
                          this.props.getDomainsByClickhouseUsageUrlData.count >
                            0 && (
                            <span>
                              Total{' '}
                              <b>{this.props.getUsageUrlCountData.count}</b>{' '}
                              {this.props.getUsageUrlCountData.count > 1
                                ? 'items'
                                : 'item'}
                            </span>
                          )}
                      </Col>
                    </Row>
                    <Row
                      style={{
                        display: 'flex',
                        marginBottom: '1rem',
                        width: '50%',
                        alignItems: 'center'
                      }}
                    >
                      <Form.Item style={{ marginBottom: 0 }}>
                        {getFieldDecorator('usageClickhouseRadio', {
                          initialValue: 'usagePart'
                        })(
                          <Radio.Group>
                            <Radio
                              value='usagePart'
                              style={{ marginRight: '1rem' }}
                            >
                              All
                            </Radio>
                            <Radio
                              value='usagePartDomain'
                              style={{ marginRight: '1rem' }}
                            >
                              Within domain
                            </Radio>
                            <Radio
                              value='usagePartSource'
                              style={{ marginRight: '1rem' }}
                            >
                              Without domain
                            </Radio>
                          </Radio.Group>
                        )}
                      </Form.Item>

                      <div style={{ marginLeft: 'auto' }}>
                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ arciveSearch: true });
                            } else {
                              this.setState({ arciveSearch: false });
                            }
                          }}
                          checked={this.state.arciveSearch}
                        >
                          Search in archive
                        </Checkbox>

                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({ clickhouseFacebook: true });
                            } else {
                              this.setState({ clickhouseFacebook: false });
                            }
                          }}
                          checked={this.state.clickhouseFacebook}
                        >
                          Facebook
                        </Checkbox>

                        <Checkbox
                          onChange={(e) => {
                            if (e.target.checked) {
                              this.setState({
                                clickhouseFacebookNotDefined: true
                              });
                            } else {
                              this.setState({
                                clickhouseFacebookNotDefined: false
                              });
                            }
                          }}
                          checked={this.state.clickhouseFacebookNotDefined}
                        >
                          Facebook not defined
                        </Checkbox>
                      </div>
                    </Row>
                  </Form>
                </div>
                <div className='search-tab-usages ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                  <Row
                    style={{
                      paddingTop: '2rem'
                    }}
                  >
                    <div className='ant-col-xs-24'>
                      <div className='filter-fields'>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            width: '100%'
                          }}
                        >
                          <Button
                            type='primary'
                            onClick={() =>
                              this.resetClickhouseSightingsFilter()
                            }
                            style={{ width: '84px' }}
                          >
                            Reset
                          </Button>
                          <ImageStatus
                            params={
                              this.state.sightingsClickhouseFilters.imageStatus
                            }
                            statuses={Object.values(IMAGE_STATUSES)}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  imageStatus: filter
                                }
                              })
                            }
                          />
                          <AgencyId
                            params={
                              this.state.sightingsClickhouseFilters.agencyId
                            }
                            agencies={this.props.getImagesTableAgenciesData}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  agencyId: filter
                                }
                              })
                            }
                            setIsCopyright={(state) =>
                              this.setState({
                                copyrightClickhouse: state
                              })
                            }
                            isCopyright={this.state.copyrightClickhouse}
                          />
                          <Country
                            params={
                              this.state.sightingsClickhouseFilters.country
                            }
                            countries={this.props.getCountriesListData}
                            isUndefineCountry={
                              this.state.undefineCountryClickhouse
                            }
                            onChangeDefine={(state) => {
                              if (
                                state.target.value ===
                                'undefineCountryClickhouse'
                              ) {
                                this.setState({
                                  undefineCountryClickhouse: true
                                });
                              } else {
                                this.setState({
                                  undefineCountryClickhouse: false
                                });
                              }
                            }}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  country: filter
                                }
                              })
                            }
                          />
                          <NonVerifiedCountry
                            params={
                              this.state.sightingsClickhouseFilters
                                .scrapedCountry
                            }
                            countries={this.props.getCountriesListData}
                            isUndefineCountry={
                              this.state.undefineNonCountryClickhouse
                            }
                            onChangeDefine={(state) => {
                              if (
                                state.target.value ===
                                'undefineNonCountryClickhouse'
                              ) {
                                this.setState({
                                  undefineNonCountryClickhouse: true
                                });
                              } else {
                                this.setState({
                                  undefineNonCountryClickhouse: false
                                });
                              }
                            }}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  scrapedCountry: filter
                                }
                              })
                            }
                          />
                          <ImageId
                            params={
                              this.state.sightingsClickhouseFilters.imageId
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  imageId: filter
                                }
                              })
                            }
                            hasExactMatch
                            setIsExactMatch={(state) =>
                              this.setState({
                                imageIdExactSearch: state
                              })
                            }
                            isExactMatch={this.state.imageIdExactSearch}
                          />
                          <ImageUrl
                            params={
                              this.state.sightingsClickhouseFilters.imageUrl
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  imageUrl: filter
                                }
                              })
                            }
                          />
                          <Domain
                            params={
                              this.state.sightingsClickhouseFilters.domain
                            }
                            exact={this.state.exactMatchesClickhouse}
                            onChangeExact={(state) =>
                              this.setState({
                                exactMatchesClickhouse: state
                              })
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  domain: filter
                                }
                              })
                            }
                          />
                          <UsageUrl
                            params={
                              this.state.sightingsClickhouseFilters.usageUrl
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  usageUrl: filter
                                }
                              })
                            }
                          />
                          <FoundAtFilter
                            params={this.state.sightingsClickhouseFilters.dates}
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  dates: filter
                                }
                              })
                            }
                          />
                          <DifferenceFilter
                            params={
                              this.state.sightingsClickhouseFilters.difference
                            }
                            onChange={(filter) =>
                              this.setState({
                                sightingsClickhouseFilters: {
                                  ...this.state.sightingsClickhouseFilters,
                                  difference: filter
                                }
                              })
                            }
                          />
                          <div
                            style={{
                              width: '4%',
                              padding: '0 3px'
                            }}
                          >
                            <Form.Item>
                              <Select
                                style={{
                                  width: '100%'
                                }}
                                defaultValue='null'
                                value={String(
                                  this.state.usagesClickhouseUrlSelectFilters
                                    .pursuable
                                )}
                                onChange={(value) =>
                                  this.setState({
                                    usagesClickhouseUrlSelectFilters: {
                                      ...this.state
                                        .usagesClickhouseUrlSelectFilters,
                                      pursuable: value
                                    }
                                  })
                                }
                              >
                                <Option key='all' value='null'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                          <div
                            style={{
                              width: '4%',
                              paddingRight: '6px',
                              paddingLeft: '3px'
                            }}
                          >
                            <Form.Item>
                              <Select
                                style={{
                                  width: '100%'
                                }}
                                defaultValue='null'
                                value={String(
                                  this.state.usagesClickhouseUrlSelectFilters
                                    .blacklisted
                                )}
                                onChange={(value) =>
                                  this.setState({
                                    usagesClickhouseUrlSelectFilters: {
                                      ...this.state
                                        .usagesClickhouseUrlSelectFilters,
                                      blacklisted: value
                                    }
                                  })
                                }
                              >
                                <Option key='all' value='null'>
                                  All
                                </Option>
                                <Option key='true' value='true'>
                                  True
                                </Option>
                                <Option key='false' value='false'>
                                  False
                                </Option>
                              </Select>
                            </Form.Item>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Row>
                  {this.props.getDomainsByClickhouseUsageUrlData?.hasOwnProperty(
                    'content'
                  ) && (
                    <UsageUrlTable
                      noDataMsg='No data for this domain'
                      tableFor='clickhouseUsageUrl'
                      tableColumns={USAGE_URL_TABLE_COLUMNS}
                      tableData={this.prepareClickhouseUsageUrlTableData()}
                      paginationOptions={
                        this.state.usageClickhouseUrlPaginationOptions
                      }
                      selectedFiltersFields={this.state.selectedDomainsFields}
                      onChangePagination={this.handleTablePaginationChange}
                      handleChangeColumnSort={this.handleColumnSortChange}
                      sortingOptions={
                        this.state.usageClickhouseUrlTableSortedOption
                      }
                      redirectPermission={
                        this.props.userInfo.userPermissions?.reviewPermission
                      }
                      rowSelection={rowSelection}
                    />
                  )}
                </div>
              </TabPane>
            )}

            {this.props.userInfo.userPermissions?.tablePermission && (
              <TabPane tab='Blacklisted table' key='blacklisted'>
                <div className='filter-container'>
                  <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                    <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-16 ant-col-xl-16'>
                      <Form onSubmit={this.blacklistedDomainSearchHandler}>
                        <Row
                          style={{
                            display: 'flex',
                            marginBottom: '1rem'
                          }}
                        >
                          <Col
                            style={{
                              width: '70%',
                              marginRight: '10px'
                            }}
                          >
                            <Form.Item
                              style={{
                                marginBottom: 0
                              }}
                            >
                              <Input
                                onChange={
                                  this.blacklistedDomainSearchInputHandler
                                }
                                placeholder='Please enter domain name'
                              />
                            </Form.Item>
                          </Col>
                          <Col>
                            <Form.Item
                              style={{
                                marginBottom: 0
                              }}
                            >
                              <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-4 ant-col-xl-4'>
                                <Button type='primary' htmlType='submit'>
                                  Search
                                </Button>
                              </div>
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                    <div className='ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24 m-b-25'>
                      <AddNewDomainToBlacklistForm
                        isVisible={this.state.showAddNewDomainModal}
                        loaderIsVisible={this.state.loaderIsVisible}
                        onCancel={this.handleCloseBlacklistedDomainModal}
                        onCreate={this.saveNewBlacklistedDomainToDB}
                      />
                      <Button onClick={() => this.addNewDomainToBlacklist()}>
                        Add new domain to blacklist
                      </Button>
                    </div>
                    {this.props.getBlacklistedDomainByNameData.hasOwnProperty(
                      'content'
                    ) && (
                      <div className='search-tab ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-24'>
                        <TableComponent
                          tableFor='blacklisted'
                          tableColumns={BLACKLISTED_TABLE_COLUMNS}
                          tableData={this.prepareBlacklistedDomainTableData()}
                          paginationOptions={
                            this.state.blacklistedPaginationOptions
                          }
                          selectedFiltersFields={
                            this.state.selectedBlacklistedFields
                          }
                          onChangePagination={this.handleTablePaginationChange}
                          handleChangeColumnSort={this.handleColumnSortChange}
                          sortingOptions={
                            this.state.blacklistedTableSortedOption
                          }
                          redirectPermission={
                            this.props.userInfo.userPermissions
                              ?.reviewPermission
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </TabPane>
            )}
          </Tabs>
        </div>
      </Spin>
    );
  }
}

function mapStateToProps({ auth, searchStore, commonStore, qc_frStore }) {
  return {
    userInfo: auth.userInfo,
    deleteDomainFromBlacklistDataErrorMessage:
      searchStore.deleteDomainFromBlacklistDataErrorMessage,
    newBatchOfBlacklistedDomainDataErrorMessage:
      searchStore.newBatchOfBlacklistedDomainDataErrorMessage,
    getDomainByNameData: searchStore.getDomainByNameData,
    getDomainByNameErrorMessage: searchStore.getDomainByNameErrorMessage,
    getDomainsByUsageUrlData: searchStore.getDomainsByUsageUrlData,
    getDomainsByClickhouseUsageUrlData:
      searchStore.getDomainsByClickhouseUsageUrlData,
    getDomainsByUsageUrlErrorMessage:
      searchStore.getDomainsByUsageUrlErrorMessage,
    getDomainsByClickhouseUsageUrlErrorMessage:
      searchStore.getDomainsByClickhouseUsageUrlErrorMessage,
    getBlacklistedDomainByNameData: searchStore.getBlacklistedDomainByNameData,
    getBlacklistedDomainByNameErrorMessage:
      searchStore.getBlacklistedDomainByNameErrorMessage,
    getImagesTableAgenciesData: commonStore.getImagesTableAgenciesData,
    getImagesByAgencyAndIdData: searchStore.getImagesByAgencyAndIdData,
    getImagesByAgencyAndIdErrorMessage:
      searchStore.getImagesByAgencyAndIdErrorMessage,
    getDomainFlowStatusesData: searchStore.getDomainFlowStatusesData,
    getCountriesListData: searchStore.getCountriesListData,
    usageImagesData: searchStore.usageImagesData,
    getUsageUrlCountData: searchStore.getUsageUrlCountData,
    getUsageUrlCountErrorMessage: searchStore.getUsageUrlCountErrorMessage,
    updateImageStatusErrorMessage: qc_frStore.updateImageStatusErrorMessage
  };
}

function mapDispatchToProps(dispatch) {
  return {
    deleteDomainFromBlacklist: bindActionCreators(
      deleteDomainFromBlacklist,
      dispatch
    ),
    addManyNewDomainsToBlacklisted: bindActionCreators(
      addManyNewDomainsToBlacklisted,
      dispatch
    ),
    getDomainByName: bindActionCreators(getDomainByName, dispatch),
    getDomainsByUsageUrl: bindActionCreators(getDomainsByUsageUrl, dispatch),
    getDomainsByClickhouseUsageUrl: bindActionCreators(
      getDomainsByClickhouseUsageUrl,
      dispatch
    ),
    getDomainsByClickhouseArchiveUsageUrl: bindActionCreators(
      getDomainsByClickhouseArchiveUsageUrl,
      dispatch
    ),
    getBlacklistedDomainByName: bindActionCreators(
      getBlacklistedDomainByName,
      dispatch
    ),
    getImagesTableAgencies: bindActionCreators(
      getImagesTableAgencies,
      dispatch
    ),
    getImagesByAgencyAndId: bindActionCreators(
      getImagesByAgencyAndId,
      dispatch
    ),
    getDomainFlowStatuses: bindActionCreators(getDomainFlowStatuses, dispatch),
    getCountriesList: bindActionCreators(getCountriesList, dispatch),
    updateImageStatus: bindActionCreators(updateImageStatus, dispatch),
    changeUsageImagesData: bindActionCreators(changeUsageImagesData, dispatch),
    changeClickhouseUsageImagesData: bindActionCreators(
      changeClickhouseUsageImagesData,
      dispatch
    ),
    setBulkChanges: bindActionCreators(setBulkChanges, dispatch),
    getUsageUrlCount: bindActionCreators(getUsageUrlCount, dispatch)
  };
}

// export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'SearchPage' })(SearchPage));
